<template>
 <div>
  <el-dialog  :center="true" :close-on-click-modal="false" title="学生基本信息" :visible="showEdit" width="99%" @close="closeEditDialog" style="margin-left: 5%;">
    <el-form ref="order" :model="order" label-width="140px" :disabled="isDetail">
      <el-form-item label="学生姓名" style="width: 100%;">
        <el-input :clearable="false" v-model="order.studentName" placeholder="请输入学生姓名" style="width: 100%" :disabled="typeCustomerFunding !== '定金'"></el-input>
      </el-form-item>
      <el-form-item label="年级" style="width: 100%;">
        <el-cascader :clearable="false" style="width: 100%;" v-model="order.grade" :options="order.gradeList" :disabled="typeCustomerFunding !== '定金'"
          :props="props"></el-cascader>
      </el-form-item>
      <el-form-item label="性别">
        <el-radio-group v-model="order.sex" :disabled="typeCustomerFunding !== '定金'">
          <el-radio label="1">男</el-radio>
          <el-radio label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="学生状态">
            <el-select class="select" filterable  :clearable="false" v-model="order.state" placeholder="请选择" style="width:100%;" :disabled="typeCustomerFunding !== '定金'">
              <el-option v-for="item in classTypes_s" :key="item.value" :value="item.value" :label="item.label">
              </el-option>
            </el-select>
      </el-form-item>

      <el-form-item label="销售">
           <el-select v-model="customerAccountName" filterable  :clearable="false"  placeholder="请选择销售" style="width:100%;"  :disabled="typeCustomerFunding !== '定金'">
              <el-option v-for="item in optionsList" :key="item.id" :label="item.label" :value="item.id"></el-option>
           </el-select>
           <!-- <el-input :clearable="false" v-model="customerAccountName" placeholder="请输入销售姓名" style="width: 100%" v-if="typeCustomerFunding !== '定金'" :disabled="typeCustomerFunding !== '定金'"></el-input> -->
      </el-form-item>

      <el-form-item label="诊断师">
           <el-select v-model="customerAccountName11" filterable  :clearable="false"  placeholder="请选择诊断师" style="width:100%;" :disabled="typeCustomerFunding !== '定金'">
              <el-option v-for="item in optionsList111" :key="item.teacherId" :label="item.teacherName"
                :value="item.teacherId"></el-option>
           </el-select>
      </el-form-item>

      <el-form-item label="规划师" v-if="typeCustomerFunding != '定金'">
           <el-select v-model="customerAccountName111" filterable  :clearable="false"  placeholder="请选择规划师" style="width:100%;" @change="handlecustomerAccountName111">
              <el-option v-for="item in optionsList1111" :key="item.teacherId" :label="item.teacherName"
                :value="item.teacherId"></el-option>
           </el-select>

      </el-form-item>
        <!-- <el-form-item label="所在地域:">
            <el-select v-model="order.regionName" :clearable="false" filterable placeholder="请选择所在地域" style="width:100%;" :disabled="typeCustomerFunding !== '定金'">
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
              :value="item.dictType"></el-option>
            </el-select>
        </el-form-item> -->


        <el-form-item label="家庭住址">
          <el-row>
            <el-col :span="4">
              <el-select v-model="regionName" :clearable="false" filterable placeholder="请选择所在地域" style="width:100%;"  @change="handleClear" :disabled="typeCustomerFunding !== '定金'">
                <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue" :value="item.dictType"></el-option>
              </el-select>
            </el-col>
            <el-col :span="20">
              <el-autocomplete
                style="width:100%;" 
                v-model="newaddress"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入上课地点，例如：小区楼号，大厦名称"
                :clearable="false"
                :disabled="typeCustomerFunding !== '定金'"
                @clear="handleautocompleteClear"
                @select="handleSelect">
                  <template slot-scope="{ item }">
                    <span style="float: left">{{ item.value }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ item.address }}</span>
                    <i style="float: right; margin-top: 10px;  margin-right: 5px;" class="el-icon-location-information"></i>
                  </template>
              </el-autocomplete>
            </el-col>
          </el-row>
      </el-form-item>
      <el-form-item label="详细地址">
        <el-input  :disabled="typeCustomerFunding !== '定金'" v-model="detailedAddress" placeholder="请输入单元、楼层、门牌号"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input  :disabled="typeCustomerFunding !== '定金'" v-model="remarks" type="textarea"  :autosize="{ minRows: 6, maxRows: 6 }" placeholder="除详细地址外，需要同步给老师的信息"></el-input>
      </el-form-item>


      <el-form-item label="备用地址" v-if="typeCustomerFunding === '定金'">
          <div style="width: 100%;text-align: start; display: flex; padding-top: 10px;">
            <div style="font-size: 20px;height: 20px; width: 20px;border: 1px solid #fff;" @click="handleAdd" class="el-icon-circle-plus-outline" ></div>
            <div style="font-size: 20px;height: 20px; width: 20px;border: 1px solid #fff;margin-left: 10px;" @click="handleRemove" class="el-icon-remove-outline" ></div>
          </div>
        </el-form-item>
      <el-form-item label="" v-if="ListDataLngLat.length > 0" >
          <div v-for="(rowItme,rowIndex) in ListDataLngLat" :key="rowIndex" style="margin-bottom: 40px; margin-top: 10px;">
            <el-form-item label="家庭住址" prop="regionName" style="margin-bottom: 10px;">
              <el-row>
                <el-col :span="4">
                  <el-select v-model="rowItme.regionName" clearable filterable placeholder="请选择所在地域" style="width:100%;"  @change="handleClears(rowItme,rowIndex)" :disabled="typeCustomerFunding !== '定金'">
                    <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue" :value="item.dictType"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="20">
                  <el-autocomplete
                    :disabled="typeCustomerFunding !== '定金'"
                    style="width:100%;" 
                    v-model="rowItme.newaddress"
                    :fetch-suggestions="querySearchAsyncs"
                    placeholder="请输入上课地点，例如：小区楼号，大厦名称"
                    clearable
                    @clear="handleautocompleteClears(rowItme,rowIndex)"
                    @select="handleSelects(rowItme,$event)">
                      <template slot-scope="{ item }">
                        <span style="float: left">{{ item.value }}</span>
                        <span style="float: right; color: #8492a6; font-size: 13px">{{ item.address }}</span>
                        <i style="float: right; margin-top: 10px;  margin-right: 5px;" class="el-icon-location-information"></i>
                      </template>
                  </el-autocomplete>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="详细地址" style="margin-bottom: 10px;">
              <el-input :disabled="typeCustomerFunding !== '定金'" v-model="rowItme.detailedAddress" placeholder="请输入单元、楼层、门牌号"></el-input>
            </el-form-item>
            <el-form-item label="备注" style="margin-bottom: 10px;">
              <el-input :disabled="typeCustomerFunding !== '定金'" v-model="rowItme.remarks" type="textarea"  :autosize="{ minRows: 6, maxRows: 6 }" placeholder="除详细地址外，需要同步给老师的信息"></el-input>
            </el-form-item>
          </div>
      </el-form-item>





      <!-- <el-form-item label="家庭住址" style="width: 100%;">
        <el-input v-model="order.address" :clearable="false" placeholder="请输入家庭住址" style="width: 100%" :disabled="typeCustomerFunding !== '定金'"></el-input>
      </el-form-item> -->

      
      <el-form-item label="家长电话" style="width: 100%;">
        <el-input :clearable="false" v-model="order.parentPhoneNumber" @input="phoneChange" placeholder="请输入家长电话" :disabled="typeCustomerFunding !== '定金'"
          style="width: 100%"></el-input>
      </el-form-item>
      <el-form-item label="课程类别">
        <el-cascader :clearable="false" style="width: 100%;" v-model="order.courseCategoryIds" :options="categoryList" :disabled="typeCustomerFunding !== '定金'"
          :props="propsCategory"></el-cascader>
      </el-form-item>
      <el-form-item label="学生类型">
        <el-select v-model="isClassType" style="width:100%;" placeholder="请选择学生类型" filterable :clearable="false" :disabled="typeCustomerFunding !== '定金'" >
          <!-- <el-option v-for="item in classTypsArr" :key="item.value" :label="item.label" :value="item.value"></el-option> -->
          <el-option v-for="item in teacherss" :key="item.id" :label="item.name" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="线上诊断教师">
        <el-select multiple filterable   v-model="order.teacherIdOnlineArr" :clearable="false" style="width: 100%;" placeholder="请选择诊断老师" :disabled="typeCustomerFunding !== '定金'">
          <el-option v-for="item in teachers" :key="item.id" :label="item.realname" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="线上诊断时间" id="time">
        <el-date-picker v-model="order.onTime" type="date" style="width: 30%;" value-format="yyyy-MM-dd" :disabled="typeCustomerFunding !== '定金'"
          placeholder="请选择诊断日期" :clearable="false">
        </el-date-picker>
        <mz-time-select style="width: 30%; display:inline-block" :childPlaceholder="'开始时间'" :timePeriod="'start1'"  class="box" :class="typeCustomerFunding !== '定金' ? 'add' :  ''"
          @startTimeSelect="startTimeSelect" v-model="order.startTimeHour"
          :valueTime="order.startTimeHour"></mz-time-select>
        <span style="margin-left:5px"></span>
        <mz-time-select @clean="clean" style="width: 30%;display:inline-block" :childPlaceholder="'结束时间'" class="box" :class="typeCustomerFunding !== '定金' ? 'add' :  ''"
          :timePeriod="'end1'" @startTimeSelect="startTimeSelect" v-model="order.onEndTime"
          :valueTime="order.onEndTime"></mz-time-select>
        <el-checkbox v-model="checked" :disabled="typeCustomerFunding !== '定金'">是否线上预约</el-checkbox>
      </el-form-item>
      <el-form-item label="线下诊断教师">
        <el-select multiple  v-model="order.teacherIdOfflineArr" filterable   :clearable="false" style="width: 100%;" placeholder="请选择诊断老师" :disabled="typeCustomerFunding !== '定金'">
          <el-option v-for="item in teachers" :key="item.id" :label="item.realname" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="线下诊断时间" id="time" style="margin-bottom: 0;">
        <el-date-picker  style="width: 30%;" v-model="order.offTime" type="date" value-format="yyyy-MM-dd" :disabled="typeCustomerFunding !== '定金'"
          placeholder="请选择诊断日期" :clearable="false">
        </el-date-picker>
        <mz-time-select @clean="clean" style="width: 30%; display:inline-block" :childPlaceholder="'开始时间'" class="box"  :class="typeCustomerFunding !== '定金' ? 'add' :  ''"
          :timePeriod="'start'" @startTimeSelect="startTimeSelect" v-model="order.OffTimeHour"
          :valueTime="order.OffTimeHour"></mz-time-select>
        <span style="margin-left:5px"></span>
        <mz-time-select @clean="clean" style="width: 30%;display:inline-block" :childPlaceholder="'结束时间'" class="box"  :class="typeCustomerFunding !== '定金' ? 'add' :  ''"
          :timePeriod="'end'" @startTimeSelect="startTimeSelect" v-model="order.offEndTime"
          :valueTime="order.offEndTime"></mz-time-select>
        <el-checkbox v-model="checked1" :disabled="typeCustomerFunding !== '定金'">是否线下预约</el-checkbox>
      </el-form-item>

      <el-form-item label="授课方式">
        <el-radio-group v-model="order.educationType" :disabled="typeCustomerFunding !== '定金'">
          <el-radio label="2">上门</el-radio>
          <el-radio label="3">门店</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- <el-form-item label="备注" style="margin-top: 20px;" >
        <el-input :rows="2" type="textarea" placeholder="请输入诊断备注" v-model="order.remarks" :disabled="typeCustomerFunding !== '定金'">
        </el-input>
      </el-form-item> -->


      <el-form-item label="客户需求" style="margin-top: 20px;" >
         <div  style="margin: 10px 0px; width: 97%;border: 1px solid #ccc;padding: 10px 7px;margin-top: 20px;height: 180px;overflow-y: auto;border-radius: 5px;margin-left: 11px;">
          <div style="margin: 10px 0px;" v-for="(itme,index) in textareaJson" :key="index">{{ itme.remark }} {{ itme.remarkDate }} </div>
         </div>
         <el-input type="textarea" v-if="typeCustomerFunding === '定金' && !isDetail"  style="width: 100%;margin: 10px;" placeholder="请输入客户需求" :autosize="{ minRows: 6, maxRows: 6 }"  v-model="newTextareaJson"  maxlength="99999999"  show-word-limit  > </el-input>
      </el-form-item>


      <el-form-item label="订单状态" v-if="typeCustomerFunding === '定金'">
          <div>
            <el-select  v-model="OrderStatus" filterable  :clearable="false" style="width: 100%;" placeholder="请选择订单状态" @change="changeOrderStatus" size="small" :disabled="isOrderStatusShow === 1 || isOrderStatusShow === 2 || isOrderStatusShow === 3">
              <el-option v-for="item in optionOrderStatus" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </div>
     </el-form-item>


      <el-form-item label="未成单的原因" v-if="typeCustomerFunding === '定金' && isOrderStatusTextarea">
          <div>
            <el-input v-model="isOrderStatusTextarea"  type="textarea"  :autosize="{ minRows: 8, maxRows: 8 }"  show-word-limit  maxlength="9999999"  placeholder="请输入原因"></el-input>
          </div>
     </el-form-item>





      <el-divider  v-if="typeCustomerFunding === '成单' && isClassType === 1"  content-position="center"> 签约产品 </el-divider>

      <el-form-item v-if="typeCustomerFunding === '成单' &&  isClassType === 1" label="" style="width: 89%;">
        <div style="display: flex;justify-content: center;">
          <el-button size="small" type="primary" @click="handleToAdd">添加/修改课时方案</el-button>
          <el-button size="small" type="primary" @click="handleToView">历史记录</el-button>
        </div>
      </el-form-item>

      <el-form-item v-if="typeCustomerFunding === '成单' && isClassType === 1" label="签约课时方案" style="width: 100%;">
        <el-select  filterable  v-model="contractScheme" size="small" style="margin-top: 5px;width: 100%;" :disabled="true" placeholder="">
          <el-option v-for="item in payTypessss" :key="item.id" :label="item.signContractName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="typeCustomerFunding === '成单' && isClassType === 1" label="签约开始时间" style="width: 100%;">
        <el-input v-model="contractTime" :clearable="false" placeholder="" style="width: 100%" :disabled="true"></el-input>
      </el-form-item> 







      <el-divider content-position="center"> {{ typeCustomerFunding === '退费' ? '退费信息' : '付款信息' }}</el-divider>




      <div v-if="typeCustomerFunding === '定金'">


        <!-- <el-form-item label="学生类型">
          <el-select  v-model="isClassType" filterable   :clearable="false" style="width: 100%;" placeholder="请选择学生类型" @change="changeCustomerFunding" size="small">
            <el-option v-for="item in teacherss" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->

     


        <el-form-item label="付款金额：">
          <el-input :clearable="false" v-model="paymentAmount" autocomplete="off" size="small" placeholder="请输入付款金额"  :disabled="isUpdate === 1"></el-input>
        </el-form-item>
        <el-form-item  label="收款时间：">
          <span v-if="paymentAmount" style="position: absolute; left: -90px; color: red;">*</span>
          <el-date-picker v-model="paymentAmountTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" :clearable="false" placeholder="选择收款时间" :disabled="isUpdate === 1"></el-date-picker>
        </el-form-item>
        <el-form-item   label="收款渠道：">
          <span v-if="paymentAmount" style="position: absolute; left: -90px; color: red;">*</span>
          <el-select  filterable :clearable="false"  v-model="paymentAmountChannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择收款渠道" :disabled="isUpdate === 1">
            <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <!-- <el-form-item  v-if="isClassType == 1 && isProject != 1" label="诊断课：">
          <span v-if="paymentAmount" style="position: absolute; left: -76px; color: red;">*</span>
          <el-input :clearable="false" v-model="paymentAmountCourse" autocomplete="off" size="small" placeholder="请输入诊断课" :disabled="isUpdate === 1"></el-input>
        </el-form-item> -->
       


     

        <!-- <el-form-item  v-if="isClassType == 1 && isProject === 1" label="学业课：">
          <span  v-if="paymentAmount" style="position: absolute; left: -76px; color: red;">*</span>
          <el-input :clearable="false" v-model="paymentAmountCourse" autocomplete="off" size="small" placeholder="请输入学业课" :disabled="isUpdate === 1"></el-input>
        </el-form-item>

        <el-form-item  v-if="isClassType == 3" label="学业课：">
          <span  v-if="paymentAmount" style="position: absolute; left: -76px; color: red;">*</span>
          <el-input :clearable="false" v-model="paymentAmountCourse" autocomplete="off" size="small" placeholder="请输入学业课" :disabled="isUpdate === 1"></el-input>
        </el-form-item> -->


        <el-form-item label="课程类别：">
          <span v-if="paymentAmount" style="position: absolute; left: -90px; color: red;">*</span>
          <el-select  filterable :clearable="false"  v-model="customerHourType" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择课程类别" :disabled="isUpdate === 1">
            <el-option v-for="item in payTypeLsit" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  label="课时数：">
          <span v-if="paymentAmount" style="position: absolute; left: -90px; color: red;">*</span>
          <el-input :clearable="false" v-model="customerHour" autocomplete="off" size="small" placeholder="输入课时数" :disabled="isUpdate === 1"></el-input>
        </el-form-item>






        <el-form-item  label="上传截图:">
            <span v-if="paymentAmount" style="position: absolute; left: -76px; color: red;">*</span>
            <div style="display: flex; padding-top: 5px;">
              <el-button size="small" type="primary" class="btns" :disabled="isUpdate === 1"  @click="handleUpload('定金')">点击上传</el-button>
            </div>

            <div v-if="fileAllLists.length > 0" >
               <div v-for="(itme,index) in fileAllLists" :key="index" style="margin-top: 10px;margin-left: 10px;display: flex;">
                 <img style="width: 80px; height: 80px;" :src="itme.url" alt=""  v-if="itme.url">
                 <div style="width: 100%; text-align: start; margin-left: 120px;">
                    <el-button size="small" type="primary" class="btns" @click="handleView(itme.url, itme.width, itme.height)">预览</el-button>
                    <el-button size="small" type="danger" :disabled="isUpdate === 1" class="btns" @click="handleUploadDelet(fileAllLists,index)">删除</el-button>
                 </div>
               </div>
            </div>
        </el-form-item>

      </div>






      <div v-if="typeCustomerFunding === '成单'">


        <!-- <el-form-item label="学生类型">
          <el-select  v-model="isClassType" filterable disabled  :clearable="false" style="width: 100%;" placeholder="请选择学生类型" @change="changeCustomerFunding" size="small">
            <el-option v-for="item in teacherss" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="是否收费" v-if="isClassType === 1 || isClassType === 3 ">
          <el-select :disabled="allIsUpdate === 1 && isThereACharge === 1" v-model="isThereACharge" filterable  :clearable="false" style="width: 100%;" placeholder="请选择是否收费" @change="changeisThereACharge" size="small">
            <el-option v-for="item in isThereAChargeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>


        <el-form-item  v-if="isThereACharge === 1">
          <div>
            <el-button  :type="setWay === '全款' ?'primary' : ''"  @click="handleSetWay('全款')">全款</el-button>
            <el-button  :type="setWay === '分期' ?'primary' : ''"  @click="handleSetWay('分期')">分期</el-button>
          </div>
       
        </el-form-item> 

        <el-form-item  v-if="setWay === '分期' && isThereACharge === 1 ">
          <el-button size="small" icon="el-icon-circle-plus-outline" @click="addInput11"></el-button>
          <el-button size="small" icon="el-icon-remove-outline" @click="removeItem11"></el-button>
        </el-form-item>



        <div style="padding-left: 150px; display: flex; margin-top: 20px;margin-bottom: 20px;" v-if="setWay === '分期' && isThereACharge === 1">
          <div style="padding-top: 7px;"><span style="padding-top: 7px;">合同金额：</span></div>
          <div>
            <el-input :clearable="false" v-model="contractAmount" autocomplete="off" size="small" placeholder="请输入合同金额" ></el-input>
          </div>
        </div>

        <!--  =================================================================( 全款 ) =========================================================-->

        <div style="display: flex; height: 544px; margin-bottom: 50px;" v-if="setWay === '全款' && isThereACharge === 1">


          <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
            <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> 成 单 收 费 </div>
          </div>

          <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">规划</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">诊断课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学业课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学习力课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学生个案</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长个案</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">伴读课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900;">远程路补</div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; ">

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;height: 160px; display: flex;">
                <div style="width: 44%;height: 160px; text-align: center;padding-top: 70px;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;">规划费</div>
                <div style="width: 56%; padding-top: 70px; height: 160px; ">
                   <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="Plan" autocomplete="off" size="small" placeholder=""  ></el-input>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">诊断费</div>
                  <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="diagnoseMoney" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">诊断课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="diagnoseHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">诊断课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="diagnoseGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学业课费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="AcademicExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学业课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="AcademicClasses" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学业课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="classGiveHour" autocomplete="off" size="small" placeholder=" "></el-input>
                  </div>
                </div>
              </div>
             
              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学习力费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="FamilyEducationExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学习力课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="FamilyEducationClass" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学习力课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="familyGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学生个案费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="studentMoney" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学生个案课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="studentHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学生个案课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="studentGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
              </div>


              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">家长个案费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="patriarchMoney" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">家长个案课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="patriarchHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">家长个案课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="patriarchGiveHour" autocomplete="off" size="small" placeholder=" "></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">伴读课费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="AccompanyingReadingFee" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">伴读课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="AccompanyingReading" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">伴读课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="readingGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">远程路补费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="RemoteRoadRepair" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">远程路补课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="RemoteRoadRepairClass" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">远程路补课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="RemoteRoadRepairGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
              </div>

            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
              <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款时间</div>
              <div style="width: 2250px; padding-top: 20px;">
                <el-date-picker style=" width: 25%; margin-left: 10px;" :disabled="allIsUpdate === 1" v-model="PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" :clearable="false" placeholder="选择收款时间"></el-date-picker>
              </div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
              <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款渠道</div>
              <div style="width: 2250px; padding-top: 20px;">
                <el-select style="width: 25%; margin-left: 10px;" :disabled="allIsUpdate === 1"  filterable :clearable="false"  v-model="Paymentchannel" size="small"  placeholder="请选择收款渠道">
                  <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
              <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;"><span style="position: relative;  margin-top: 18px;  color: red;">*</span>收款截图</div>
              <div style="width: 2250px;padding: 15px 0px;display: flex;">
                <el-button size="small" style=" margin-left: 10px;"  :disabled="allIsUpdate === 1" type="primary" class="btns" @click="handleUpload('全款')">点击上传</el-button>
                <div v-if="chargeCollectionPicture.length > 0" style="display: flex;"> 
                    <div v-for="(item,index) in chargeCollectionPicture" :key="index" >
                      <img :src="item.url" :alt="item.name"  style="width: 50px; height: 50px; margin-left: 10px;margin-top: -7px;" >
                      <span v-if="item" @click="handleView(item.url,item.width,item.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                      <span v-if="item" @click="handleViews(chargeCollectionPicture,index)" style="color: red;margin-left: 10px;">删除</span>
                    </div>
                </div>
              </div>
            </div>

            <div style="width: 100%;overflow: hidden;"> 
              <div style="display: flex; ">
                <div style="height: 136px;width: 131px; text-align: center;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;padding-top: 55px;">备注原因</div>
                <div style="width: 2250px; padding: 0px 0px 15px 0px; display: flex; ">
                   

                      <div class="init-b" v-if="allIsUpdate === 1">
                              <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                                <div v-if="itme.commitContent">老师：{{ itme.commitContent }}</div>
                                <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                              </div>
                      </div>
                      <div style="width: 45%;margin-left: 10px; margin-top: 15px;" v-else>
                        <el-input resize="none"  type="textarea"  :autosize="{  minRows: 4, maxRows: 4 }"  v-model="chengRemarksssss"> </el-input>
                      </div>

                      <!-- <div style="width: 90px;  margin-left: 22px;   text-align: center;  font-size: 13px;  font-weight: 900;  border-right: 1px solid rgb(204, 204, 204);  padding-top: 50px;  border-left: 1px solid rgb(204, 204, 204);">审批人</div>

                      <div style="width: 45%;margin-left: 10px; margin-top: 15px;">
                        <el-select v-model="ApprovalPeople" :disabled="allIsUpdate === 1" size="small" style="width: 50%;" placeholder="请选择审批人">
                          <el-option v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                        </el-select>
                      </div> -->
                </div>
              </div>
              <div style="width: 97%; text-align: end; margin-top: -90px; ">
                  <el-button size="small"  type="primary"  :disabled="allIsUpdate === 1" @click="handleViewSet('全款','','customerInformationCollectionAudit/updateAllMoney',chengRemarksssss,ApprovalPeople, { PaymentTime, Paymentchannel, chargeCollectionPicture })" style="margin-left: 10px;">提交审批</el-button>
              </div> 
            </div>

          </div>
        </div>

        <!--  ==============================================================（ 全 款 结 束 ）========================================================= -->


        <!-- 是否收费表格展示  ========================================( 分期 ) ------====================================================== -->
     
      <div v-if="setWay === '分期' && isThereACharge === 1">

       <el-collapse  accordion v-for="(item, index) in renewalCollectionListWay" :key="index">  
         <el-collapse-item >

          <template slot="title">
            <div style="padding: 10px 40px;font-size: 15px;">第 {{  handleToString(index + 1) }} 期</div>
            <div style="padding: 10px 40px;font-size: 15px;">收款金额: {{ item.sumMoney  }}</div>
            <div style="padding: 10px 40px;font-size: 15px;">收款时间: {{ item.stagesDate  }} </div>
            <div style="padding: 10px 40px;font-size: 15px;">收款渠道: {{ 
              item.payType === 1 ? '现金' : 
              item.payType === 2 ? '微信' : 
              item.payType === 3 ? '支付宝' : 
              item.payType === 4 ? '银行卡' : 
              item.payType === 5 ? '公户' : 
              item.payType === 6 ? '小鹅通' : 
              item.payType === 7 ? '美团' : 
              item.payType === 8 ? '公户（桑穆）' : 
              item.payType === 9 ? '公户（博川）' : 
              item.payType === 10 ? '公户（蒙正心理）' : 
              item.payType === 11 ? '公户（博文睿思）' : ''
            }} </div>
          </template>
          
          <div style="display: flex; height: 544px;margin-bottom: 50px;" >




              <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
                <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> {{ '第 ' + handleToString(index + 1) + ' 期'  }} </div>
              </div>


              <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">规划</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">诊断课</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学业课</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学习力课</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学生个案</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长个案</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">伴读课</div>
                  <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900;">远程路补</div>
                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; ">

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;height: 160px; display: flex;">
                    <div style="width: 44%;height: 160px; text-align: center;padding-top: 70px;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;">规划费</div>
                    <div style="width: 56%; padding-top: 70px; height: 160px; ">
                      <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.Plan" autocomplete="off" size="small" placeholder=""></el-input>
                    </div>
                  </div>

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">诊断费</div>
                      <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.diagnoseMoney" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">诊断课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.diagnoseHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">诊断课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.diagnoseGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学业课费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.AcademicExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学业课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.AcademicClasses" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学业课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.classGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                  </div>
                
                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学习力费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.FamilyEducationExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学习力课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.FamilyEducationClass" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学习力课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.familyGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学生个案费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.studentMoney" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学生个案课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.studentHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学生个案课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.studentGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                  </div>


                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">家长个案费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.patriarchMoney" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">家长个案课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.patriarchHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">家长个案课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.patriarchGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">伴读课费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.AccompanyingReadingFee" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">伴读课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.AccompanyingReading" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">伴读课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.readingGiveHour" autocomplete="off" size="small" placeholder="(赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                  <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; ">
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">远程路补费</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.RemoteRoadRepair" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 50px;">
                      <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">远程路补课时</div>
                      <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.RemoteRoadRepairClass" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>
                    <div style="display: flex; height: 60px;">
                      <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">远程路补课时(赠送)</div>
                      <div style="width: 56%; padding-top: 10px;">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.RemoteRoadRepairGiveHour" autocomplete="off" size="small" placeholder="(赠送)"></el-input>
                      </div>
                    </div>
                  </div>

                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                  <span style="position: absolute;  margin-top: 18px;  color: red; margin-left: 5px;">*</span>
                  <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;">收款时间</div>
                  <div style="width: 2250px; padding-top: 20px;">
                    <el-date-picker style=" width: 25%; margin-left: 10px;" :disabled="item.allIsUpdate === 1" v-model="item.PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" :clearable="false" placeholder="选择收款时间"></el-date-picker>
                  </div>
                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                  <span style="position: absolute;  margin-top: 18px;  color: red; margin-left: 5px;">*</span>
                  <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;">收款渠道</div>
                  <div style="width: 2250px; padding-top: 20px;">
                    <el-select style="width: 25%; margin-left: 10px;" :disabled="item.allIsUpdate === 1" filterable :clearable="false"  v-model="item.Paymentchannel" size="small"  placeholder="请选择收款渠道">
                      <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>

                <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                  <span style="position: absolute;  margin-top: 18px;  color: red; margin-left: 5px;">*</span>
                  <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;">收款截图</div>
                  <div style="width: 2250px; padding: 15px 0px;display: flex;">
                    <el-button size="small" style=" margin-left: 10px;" :disabled="item.allIsUpdate === 1" type="primary" class="btns" @click="handleUpload('分期',index,item.chargeCollectionPicture)">点击上传</el-button>
                    <div v-for="(itmes,indexs) in item.chargeCollectionPicture"  :key="indexs"> 
                        <img  :src="itmes.url" :alt="itmes.name" style="width: 50px; height: 50px; margin-left: 10px;margin-top: -7px;" >
                        <span v-if="itmes" @click="handleView(itmes.url, itmes.width, itmes.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                        <span v-if="itmes" @click="handleViews(itmes.chargeCollectionPicture,indexs)" style="color: red;margin-left: 10px;">删除</span>
                    </div>
                  </div>
                </div>

                <div style="width: 100%; overflow: hidden;"> 
                    <div style="display: flex; ">
                      <div style="height: 136px;width: 131px; text-align: center;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;padding-top: 55px;">备注原因</div>
                      <div style="width: 2250px; padding: 0px 0px 15px 0px; display: flex; ">

                            <div class="init-b" v-if="item.allIsUpdate === 1">
                              <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in item.doubtContent" :key="index">
                                <div v-if="itme.commitContent">老师：{{ itme.commitContent }}</div>
                                <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                              </div>
                            </div>
                            <div style="width: 45%;margin-left: 10px; margin-top: 15px;" v-else>
                              <el-input resize="none"  type="textarea"  :autosize="{  minRows: 4, maxRows: 4 }"  v-model="item.chengRemarksssss"> </el-input>
                            </div>


                            <!-- <div style="width: 90px;  margin-left: 22px;   text-align: center;  font-size: 13px;  font-weight: 900;  border-right: 1px solid rgb(204, 204, 204);  padding-top: 50px;  border-left: 1px solid rgb(204, 204, 204);">审批人</div>
                            <div style="width: 45%;margin-left: 10px; margin-top: 15px;">
                              <el-select v-model="item.ApprovalPeople"  :disabled="item.allIsUpdate === 1" size="small" style="width: 50%;" placeholder="请选择审批人">
                                <el-option v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                              </el-select>
                            </div> -->
                      </div>
                    </div>
                    <div style="width: 97%; text-align: end; margin-top: -90px; ">
                        <el-button size="small"  type="primary" :disabled="item.allIsUpdate === 1"  @click="handleViewSet('分期',index,'customerInformationCollectionAudit/updateStages',item.chengRemarksssss,item.ApprovalPeople, { PaymentTime:item.PaymentTime, Paymentchannel:item.Paymentchannel, chargeCollectionPicture:item.chargeCollectionPicture, AcademicExpenses: item.AcademicExpenses, })" style="margin-left: 10px;">提交审批</el-button>
                    </div> 
                </div>

              </div>

          </div>

         </el-collapse-item>
        </el-collapse>
      
      
      </div>
       
        <!-- 是否收费表格展示  ========================================( 分期 ) ------====================================================== -->


       <!-- 是否收费表格展示  ========================================( 老样式 ) ------====================================================== -->
      
       <!-- <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="规划费：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="Plan" autocomplete="off" size="small" placeholder=""></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="学业费：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="学业课：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
        </el-form-item>

        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="学业课(赠送)：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="classGiveHour" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
        </el-form-item>
        
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="家庭教育费：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="FamilyEducationExpenses" autocomplete="off" size="small" placeholder="请输入家庭教育费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="家庭教育课：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="FamilyEducationClass" autocomplete="off" size="small" placeholder="请输入家庭教育课"></el-input>
        </el-form-item>

        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="家庭教育课(赠送)：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="familyGiveHour" autocomplete="off" size="small" placeholder="请输入家庭教育课"></el-input>
        </el-form-item>

        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="伴读费：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="AccompanyingReadingFee" autocomplete="off" size="small" placeholder="请输入伴读费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="伴读：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="AccompanyingReading" autocomplete="off" size="small" placeholder="伴读"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="伴读(赠送)：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="readingGiveHour" autocomplete="off" size="small" placeholder="伴读"></el-input>
        </el-form-item>


        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="诊断课：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="DiagnosticClass" autocomplete="off" size="small" placeholder="请输入伴读费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="诊断课费：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="DiagnosticClassFee" autocomplete="off" size="small" placeholder="伴读"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="诊断课(赠送)：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="DiagnosticClassFeeGift" autocomplete="off" size="small" placeholder="伴读"></el-input>
        </el-form-item>


        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="远程路补：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="RemoteRoadRepair" autocomplete="off" size="small" placeholder="远程路补"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="收款时间：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-date-picker v-model="PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" :clearable="false" placeholder="选择收款时间"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 1" label="收款渠道：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-select  filterable :clearable="false"  v-model="Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择收款渠道">
            <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->

         <!-- 是否收费表格展示  ========================================( 老样式 ) ------====================================================== -->

        <!-- ==============================================================================================================================收费 -->

        <el-form-item label="是否续费" v-if="isClassType === 1 || isClassType === 3">
          <el-select  :disabled="allIsUpdate === 1 && isYouWantToRenew === 1" v-model="isYouWantToRenew" filterable  :clearable="false" style="width: 100%;" placeholder="请选择是否续费" @change="changeisYouWantToRenew" size="small">
            <el-option v-for="item in isYouWantToRenewList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  v-if="isYouWantToRenew === 1">
          <el-button size="small" icon="el-icon-circle-plus-outline" @click="addInput1"></el-button>
          <el-button size="small" icon="el-icon-remove-outline" @click="removeItem1"></el-button>
        </el-form-item>

        <!-- 表格================ -->
        <div v-if="isYouWantToRenew === 1">


          <el-collapse  accordion v-for="(item, index) in renewalCollectionList" :key="index">  
            <el-collapse-item >

              <template slot="title">
                <div style="padding: 10px 40px;font-size: 15px;">续费第{{  handleToString(index + 1) }}期</div>
                <div style="padding: 10px 40px;font-size: 15px;">收款金额: {{ item.sumMoney  }}</div>
                <div style="padding: 10px 40px;font-size: 15px;">收款时间: {{ item.renewTime  }} </div>
                <div style="padding: 10px 40px;font-size: 15px;">收款渠道: {{ 
                  item.renewType === 1 ? '现金' : 
                  item.renewType === 2 ? '微信' : 
                  item.renewType === 3 ? '支付宝' : 
                  item.renewType === 4 ? '银行卡' : 
                  item.renewType === 5 ? '公户' : 
                  item.renewType === 6 ? '小鹅通' : 
                  item.renewType === 7 ? '美团' : 
                  item.renewType === 8 ? '公户（桑穆）' : 
                  item.renewType === 9 ? '公户（博川）' : 
                  item.renewType === 10 ? '公户（蒙正心理）' :
                  item.renewType === 11 ? '公户（博文睿思）' : ''
                }} </div>
              </template>


              <div style="display: flex; height: 544px;margin-bottom: 50px;" >


                <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
                  <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> {{ '续 费 第 ' + handleToString(index + 1) + ' 期'  }} </div>
                </div>


                <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">规划</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">诊断课</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学业课</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学习力课</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学生个案</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长个案</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">伴读课</div>
                    <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900;">远程路补</div>
                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; ">

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;height: 160px; display: flex;">
                      <div style="width: 44%;height: 160px; text-align: center;padding-top: 70px;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;">规划费</div>
                      <div style="width: 56%; padding-top: 70px; height: 160px; ">
                        <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.Plan" autocomplete="off" size="small" placeholder=""></el-input>
                      </div>
                    </div>

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">诊断费</div>
                        <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.diagnoseMoney" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">诊断课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.diagnoseHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">诊断课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.diagnoseGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学业课费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.AcademicExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学业课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.AcademicClasses" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学业课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.classGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>
                  
                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学习力费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.FamilyEducationExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学习力课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.FamilyEducationClass" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学习力课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.familyGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学生个案费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.studentMoney" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学生个案课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.studentHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学生个案课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.studentGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>


                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">家长个案费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.patriarchMoney" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">家长个案课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.patriarchHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">家长个案课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.patriarchGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">伴读课费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.AccompanyingReadingFee" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">伴读课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.AccompanyingReading" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">伴读课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.readingGiveHour" autocomplete="off" size="small" placeholder="(赠送)"></el-input>
                        </div>
                      </div>
                    </div>

                    <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; ">
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">远程路补费</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.RemoteRoadRepair" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 50px;">
                        <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">远程路补课时</div>
                        <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.RemoteRoadRepairClass" autocomplete="off" size="small" placeholder=""></el-input>
                        </div>
                      </div>
                      <div style="display: flex; height: 60px;">
                        <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">远程路补课时(赠送)</div>
                        <div style="width: 56%; padding-top: 10px;">
                          <el-input style="width: 90%;" class="inputcolor" :disabled="item.allIsUpdate === 1" :clearable="false" v-model="item.RemoteRoadRepairGiveHour" autocomplete="off" size="small" placeholder="(赠送)"></el-input>
                        </div>
                      </div>
                    </div>

                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
                    <span style="position: absolute;  margin-top: 18px;  color: red; margin-left: 5px;">*</span>
                    <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;">收款时间</div>
                    <div style="width: 2250px; padding-top: 20px;">
                      <el-date-picker style=" width: 25%; margin-left: 10px;" :disabled="item.allIsUpdate === 1" v-model="item.PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" :clearable="false" placeholder="选择收款时间"></el-date-picker>
                    </div>
                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                    <span style="position: absolute;  margin-top: 18px;  color: red; margin-left: 5px;">*</span>
                    <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;">收款渠道</div>
                    <div style="width: 2250px; padding-top: 20px;">
                      <el-select style="width: 25%; margin-left: 10px;" :disabled="item.allIsUpdate === 1" filterable :clearable="false"  v-model="item.Paymentchannel" size="small"  placeholder="请选择收款渠道">
                        <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </div>
                  </div>

                  <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
                    <span style="position: absolute;  margin-top: 18px;  color: red; margin-left: 5px;">*</span>
                    <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;">收款截图</div>
                    <div style="width: 2250px; padding: 15px 0px; display: flex;">
                      <el-button size="small" style=" margin-left: 10px;"  :disabled="item.allIsUpdate === 1" type="primary" class="btns" @click="handleUpload('续费',index,item.renewCollectionPicture)">点击上传</el-button>
                      <div v-if="item.renewCollectionPicture.length > 0" style="display: flex;"> 
                        <div v-for="(items,index) in item.renewCollectionPicture" :key="index" >
                          <img :src="items.url" :alt="items.name"  style="width: 50px; height: 50px; margin-left: 10px;margin-top: -7px;" >
                          <span v-if="items" @click="handleView(items.url,items.width,items.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                          <span v-if="items" @click="handleViews(item.renewCollectionPicture,index)" style="color: red;margin-left: 10px;">删除</span>
                        </div>
                      </div>
                    </div> 
                  </div>

                  <div style="width: 100%; overflow: hidden;"> 
                    <div style="display: flex; ">
                      <div style="height: 136px;width: 131px; text-align: center;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;padding-top: 55px;">备注原因</div>
                      <div style="width: 2250px; padding: 0px 0px 15px 0px; display: flex; ">
                           

                             <div class="init-b" v-if="item.allIsUpdate === 1">
                                    <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in item.doubtContent" :key="index">
                                      <div v-if="itme.commitContent">老师：{{ itme.commitContent }}</div>
                                      <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                      <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                      <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                      <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                                    </div>
                            </div>
                            <div style="width: 45%;margin-left: 10px; margin-top: 15px;" v-else>
                              <el-input resize="none"  type="textarea"  :autosize="{  minRows: 4, maxRows: 4 }"  v-model="item.chengRemarksssss"> </el-input>
                            </div>



                            <!-- <div style="width: 90px;  margin-left: 22px;   text-align: center;  font-size: 13px;  font-weight: 900;  border-right: 1px solid rgb(204, 204, 204);  padding-top: 50px;  border-left: 1px solid rgb(204, 204, 204);">审批人</div>
                            <div style="width: 45%;margin-left: 10px; margin-top: 15px;">
                              <el-select v-model="item.ApprovalPeople" size="small" :disabled="item.allIsUpdate === 1" style="width: 50%;" placeholder="请选择审批人">
                                <el-option v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                              </el-select>
                            </div> -->
                      </div>
                    </div>
                    <div style="width: 97%; text-align: end; margin-top: -90px; ">
                        <el-button size="small"  type="primary" :disabled="item.allIsUpdate === 1" @click="handleViewSet('续费',index,'customerInformationCollectionAudit/updateRenew',item.chengRemarksssss,item.ApprovalPeople, { PaymentTime:item.PaymentTime, Paymentchannel:item.Paymentchannel, chargeCollectionPicture:item.renewCollectionPicture })" style="margin-left: 10px;">提交审批</el-button>
                    </div> 
                  </div>

                </div>

              </div>

            </el-collapse-item>
          </el-collapse>

        </div>

        <!-- <el-form-item v-if="isYouWantToRenew === 1 && isClassType === 1" style="margin-bottom: 100px;margin-top: 50px; margin-left: -100px;">
          <el-form-item v-for="(item, index) in renewalCollectionList" :key="index" :label="'第' + (index + 1) + '期'" style="margin-left: -60px;" :style="{ marginTop: index != 0 ? '70px' : '0px',}">

              <el-form-item label="学业费：" style="position: relative; top: 60px;">
                <el-input :clearable="false" v-model="item.AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业费"></el-input>
              </el-form-item>

              <el-form-item label="学业课：" style="position: relative; top: 60px;">
                <el-input :clearable="false" v-model="item.AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
              </el-form-item>

              <el-form-item label="学业课(赠送)：" style="position: relative; top: 60px;">
                <el-input :clearable="false" v-model="item.classGiveHour" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
              </el-form-item>

              <el-form-item label="家庭教育费：" style="position: relative; top: 60px;">
                 <el-input :clearable="false" v-model="item.FamilyEducationExpenses" autocomplete="off" size="small" placeholder="请输入家庭教育费"></el-input>
              </el-form-item>

              <el-form-item label="家庭教育课：" style="position: relative; top: 60px;">
               <el-input :clearable="false" v-model="item.FamilyEducationClass" autocomplete="off" size="small" placeholder="请输入家庭教育课"></el-input>
              </el-form-item>

              <el-form-item label="家庭教育课(赠送)：" style="position: relative; top: 60px;">
               <el-input :clearable="false" v-model="item.familyGiveHour" autocomplete="off" size="small" placeholder="请输入家庭教育课"></el-input>
              </el-form-item>

              <el-form-item label="伴读费：" style="position: relative; top: 60px;">
               <el-input :clearable="false" v-model="item.AccompanyingReadingFee" autocomplete="off" size="small" placeholder="请输入伴读费"></el-input>
              </el-form-item>

              <el-form-item label="伴读：" style="position: relative; top: 60px;">
                <el-input :clearable="false" v-model="item.AccompanyingReading" autocomplete="off" size="small" placeholder="伴读"></el-input>
              </el-form-item>

              <el-form-item label="伴读(赠送)：" style="position: relative; top: 60px;">
                <el-input :clearable="false" v-model="item.readingGiveHour" autocomplete="off" size="small" placeholder="伴读"></el-input>
              </el-form-item>

              <el-form-item label="诊断课：" style="position: relative; top: 60px;">
               <el-input :clearable="false" v-model="item.DiagnosticClass" autocomplete="off" size="small" placeholder="请输入伴读费"></el-input>
              </el-form-item>

              <el-form-item label="诊断课费：" style="position: relative; top: 60px;">
                <el-input :clearable="false" v-model="item.DiagnosticClassFee" autocomplete="off" size="small" placeholder="伴读"></el-input>
              </el-form-item>

              <el-form-item label="诊断课(赠送)：" style="position: relative; top: 60px;">
                <el-input :clearable="false" v-model="item.DiagnosticClassFeeGift" autocomplete="off" size="small" placeholder="伴读"></el-input>
              </el-form-item>

              <el-form-item label="远程路补：" style="position: relative; top: 60px;">
                <el-input :clearable="false" v-model="item.RemoteRoadRepair" autocomplete="off" size="small" placeholder="远程路补"></el-input>
              </el-form-item>

              <el-form-item label="收款时间：" style="position: relative; top: 60px;">
                <el-date-picker v-model="item.PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" :clearable="false" placeholder="选择收款时间"></el-date-picker>
              </el-form-item>

              <el-form-item label="收款渠道：" style="position: relative; top: 60px;">
                <el-select  filterable :clearable="false"  v-model="item.Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择收款渠道">
                  <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>

           
          </el-form-item>
        </el-form-item> -->





        <!-- <el-form-item label="是否收费" v-if="isClassType === 3">
          <el-select  v-model="isThereACharge" filterable  :clearable="false" style="width: 100%;" placeholder="请选择是否收费" @change="changeisThereACharge" size="small">
            <el-option v-for="item in isThereAChargeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->


        <!-- <el-form-item  v-if="isThereACharge === 1 && isClassType === 3" label="学业费：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 3" label="学业课：" style="margin-left: 80px; margin-bottom: 0px;">
          <el-input :clearable="false" v-model="AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
        </el-form-item> -->
        
        <!-- <el-form-item  v-if="isThereACharge === 1 && isClassType === 3" label="学业课(赠送)：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="classGiveHour" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
        </el-form-item>

        <el-form-item  v-if="isThereACharge === 1 && isClassType === 3" label="诊断课：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="DiagnosticClass" autocomplete="off" size="small" placeholder="请输入伴读费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 3" label="诊断课费：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="DiagnosticClassFee" autocomplete="off" size="small" placeholder="伴读"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 3" label="诊断课(赠送)：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="DiagnosticClassFeeGift" autocomplete="off" size="small" placeholder="伴读"></el-input>
        </el-form-item>
        
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 3" label="家庭教育费：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="FamilyEducationExpenses" autocomplete="off" size="small" placeholder="请输入家庭教育费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 3" label="家庭教育课：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="FamilyEducationClass" autocomplete="off" size="small" placeholder="请输入家庭教育课"></el-input>
        </el-form-item>

        <el-form-item  v-if="isThereACharge === 1 && isClassType === 3" label="家庭教育课(赠送)：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="familyGiveHour" autocomplete="off" size="small" placeholder="请输入家庭教育课"></el-input>
        </el-form-item>

        <el-form-item  v-if="isThereACharge === 1 && isClassType === 3" label="伴读费：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="AccompanyingReadingFee" autocomplete="off" size="small" placeholder="请输入伴读费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 3" label="伴读：" style="margin-left: 80px;margin-bottom: 0px;">
          <el-input :clearable="false" v-model="AccompanyingReading" autocomplete="off" size="small" placeholder="伴读"></el-input>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 3" label="伴读(赠送)：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="readingGiveHour" autocomplete="off" size="small" placeholder="伴读"></el-input>
        </el-form-item> -->

        <!-- <el-form-item  v-if="isThereACharge === 1 && isClassType === 3" label="收款时间：" style="margin-left: 80px;margin-bottom: 0px; ">
          <el-date-picker v-model="PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" :clearable="false" placeholder="选择收款时间"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isThereACharge === 1 && isClassType === 3" label="收款渠道：" style="margin-left: 80px;">
          <el-select  filterable :clearable="false"  v-model="Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择收款渠道">
            <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->



        <!-- <el-form-item label="是否续费" v-if="isClassType === 3">
          <el-select  v-model="isYouWantToRenew" filterable  :clearable="false" style="width: 100%;" placeholder="请选择是否续费" @change="changeisYouWantToRenew" size="small">
            <el-option v-for="item in isYouWantToRenewList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item  v-if="isYouWantToRenew === 1 && isClassType === 3">
          <el-button size="small" icon="el-icon-circle-plus-outline" @click="addInput1"></el-button>
          <el-button size="small" icon="el-icon-remove-outline" @click="removeItem1"></el-button>
        </el-form-item> -->


        
        <!-- <el-form-item v-if="isYouWantToRenew === 1 && isClassType === 3">
          <el-form-item v-for="(item, index) in renewalCollectionList" :key="index" :label="'第' + (index + 1) + '期'" style="margin-left: -150px; margin-bottom: 100px;">

              <el-form-item label="学业费：" style="position: relative; top: 60px;">
                <el-input :clearable="false" v-model="item.AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业费"></el-input>
              </el-form-item>
              <el-form-item label="学业课：" style="position: relative; top: 60px;">
                 <el-input :clearable="false" v-model="item.AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
              </el-form-item>
              
              <el-form-item label="学业课(赠送)：" style="position: relative; top: 60px;">
                <el-input :clearable="false" v-model="item.classGiveHour" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
              </el-form-item>

              <el-form-item label="诊断课：" style="position: relative; top: 60px;">
               <el-input :clearable="false" v-model="item.DiagnosticClass" autocomplete="off" size="small" placeholder="请输入伴读费"></el-input>
              </el-form-item>

              <el-form-item label="诊断课费：" style="position: relative; top: 60px;">
                <el-input :clearable="false" v-model="item.DiagnosticClassFee" autocomplete="off" size="small" placeholder="伴读"></el-input>
              </el-form-item>

              <el-form-item label="诊断课(赠送)：" style="position: relative; top: 60px;">
                <el-input :clearable="false" v-model="item.DiagnosticClassFeeGift" autocomplete="off" size="small" placeholder="伴读"></el-input>
              </el-form-item>

              <el-form-item label="家庭教育费：" style="position: relative; top: 60px;">
                 <el-input :clearable="false" v-model="item.FamilyEducationExpenses" autocomplete="off" size="small" placeholder="请输入家庭教育费"></el-input>
              </el-form-item>

              <el-form-item label="家庭教育课：" style="position: relative; top: 60px;">
               <el-input :clearable="false" v-model="item.FamilyEducationClass" autocomplete="off" size="small" placeholder="请输入家庭教育课"></el-input>
              </el-form-item>

              <el-form-item label="家庭教育课(赠送)：" style="position: relative; top: 60px;">
               <el-input :clearable="false" v-model="item.familyGiveHour" autocomplete="off" size="small" placeholder="请输入家庭教育课"></el-input>
              </el-form-item>

              <el-form-item label="伴读费：" style="position: relative; top: 60px;">
               <el-input :clearable="false" v-model="item.AccompanyingReadingFee" autocomplete="off" size="small" placeholder="请输入伴读费"></el-input>
              </el-form-item>

              <el-form-item label="伴读：" style="position: relative; top: 60px;">
                <el-input :clearable="false" v-model="item.AccompanyingReading" autocomplete="off" size="small" placeholder="伴读"></el-input>
              </el-form-item>

              <el-form-item label="伴读(赠送)：" style="position: relative; top: 60px;">
                <el-input :clearable="false" v-model="item.readingGiveHour" autocomplete="off" size="small" placeholder="伴读"></el-input>
              </el-form-item>

              <el-form-item label="收款时间：" style="position: relative; top: 60px;">
                 <el-date-picker v-model="item.PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" :clearable="false" placeholder="选择收款时间"></el-date-picker>
              </el-form-item>
              <el-form-item label="收款渠道：" style="position: relative; top: 60px;">
                 <el-select  filterable :clearable="false"  v-model="item.Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择收款渠道">
                    <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                 </el-select>
              </el-form-item>
              
          </el-form-item>
        </el-form-item> -->

         <el-form-item label="是否转规划" v-if="isClassType === 3">
          <el-select  v-model="isProject" filterable  :clearable="false" style="width: 100%;" placeholder="请选择是否转规划"  size="small">
            <el-option v-for="item in isThereARefundList1" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="是否退费">
          <el-select  v-model="isThereARefund" filterable  :clearable="false" style="width: 100%;" placeholder="请选择是否退费"  size="small">
            <el-option v-for="item in isThereARefundList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

       <!-- <el-form-item label="是否关单" v-if="isThereACharge === 2">
          <el-select  v-model="isCustomsDeclaration" filterable  :clearable="false" style="width: 100%;" placeholder="请选择是否关单" @change="changeisThereARefund" size="small">
            <el-option v-for="item in isThereARefundListt" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="备注原因" v-if="isCustomsDeclaration === 1 && isThereACharge === 2">
            <el-input v-model="isCustomsDeclarationchengRemarks" :autosize="{ minRows: 6, maxRows: 6 }" type="textarea"  placeholder="请输入备注原因" maxlength="300" show-word-limit></el-input>
        </el-form-item>


        <el-form-item style="" label="审批人">
          <el-select v-model="ApprovalPeople" size="small" style="width: 100%;" placeholder="请选择审批人" >
              <el-option v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="备注">
            <el-input v-model="chengRemarks" :autosize="{ minRows: 6, maxRows: 6 }" type="textarea"  placeholder="请输入备注" maxlength="300" show-word-limit></el-input>
        </el-form-item> -->

      </div>









      <div v-if="typeCustomerFunding === '退费'">


        <el-form-item label="客资状态">
           <div>{{ isCustomerStatus === 1 ? '定金客资' : isCustomerStatus === 2 ? '成单客资' : '' }}</div>
        </el-form-item>


        <!-- <el-form-item label="学生类型">
          <el-select  v-model="isClassType" filterable  disabled :clearable="false" style="width: 100%;" placeholder="请选择学生类型" @change="changeCustomerFunding">
            <el-option v-for="item in teacherss" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item> -->


        <div style="display: flex; height: 544px; margin-bottom: 50px;" >


          <div style="width: 5%; border-top: 1px solid #ccc; border-bottom: 1px solid #ccc; border-left: 1px solid #ccc;  ">
            <div style="margin-left: 40%; writing-mode: vertical-rl; margin-top: 200px; font-weight: 900;"> 退费信息 </div>
          </div>

          <div style="width: 95%; border: 1px solid #ccc; overflow-y: auto;">

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">规划</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">诊断课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学业课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学习力课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">学生个案</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">家长个案</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900; border-right: 1px solid #ccc;">伴读课</div>
              <div style="width: 300px; text-align: center;padding-top: 20px;font-size: 15px;font-weight: 900;">远程路补</div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 160px;display: flex; ">

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;height: 160px; display: flex;">
                <div style="width: 44%;height: 160px; text-align: center;padding-top: 70px;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;">规划费</div>
                <div style="width: 56%; padding-top: 70px; height: 160px; ">
                   <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="Plan" autocomplete="off" size="small" placeholder=""></el-input>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">诊断费</div>
                  <div style="width: 56%; padding-top: 15px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="diagnoseMoney" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">诊断课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="diagnoseHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">诊断课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="diagnoseGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学业课费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="AcademicExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 44%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学业课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="AcademicClasses" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 44%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学业课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="classGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
              </div>
             
              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学习力费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="FamilyEducationExpenses" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学习力课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="FamilyEducationClass" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学习力课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="familyGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">学生个案费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="studentMoney" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">学生个案课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="studentHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">学生个案课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="studentGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
              </div>


              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">家长个案费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="patriarchMoney" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">家长个案课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="patriarchHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">家长个案课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="patriarchGiveHour" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">伴读课费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="AccompanyingReadingFee" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">伴读课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="AccompanyingReading" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">伴读课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="readingGiveHour" autocomplete="off" size="small" placeholder="(赠送)"></el-input>
                  </div>
                </div>
              </div>

              <div style="width: 12.45%; text-align: center;font-size: 12px;font-weight: 900; ">
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc;padding-top: 15px;">远程路补费</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="RemoteRoadRepair" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 50px;">
                  <div style="width: 45%; text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc; border-bottom: 1px solid #ccc; padding-top: 15px;">远程路补课时</div>
                  <div style="width: 56%; padding-top: 10px; border-bottom: 1px solid #ccc;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="RemoteRoadRepairClass" autocomplete="off" size="small" placeholder=""></el-input>
                  </div>
                </div>
                <div style="display: flex; height: 60px;">
                  <div style="width: 45%;text-align: center;font-size: 12px;font-weight: 900; border-right: 1px solid #ccc;  padding-top: 15px;">远程路补课时(赠送)</div>
                  <div style="width: 56%; padding-top: 10px;">
                    <el-input style="width: 90%;" class="inputcolor" :disabled="allIsUpdate === 1" :clearable="false" v-model="RemoteRoadRepairGiveHour" autocomplete="off" size="small" placeholder="(赠送)"></el-input>
                  </div>
                </div>
              </div>

            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; ">
              <!-- <span style="position: absolute;  margin-top: 18px;  color: red;">*</span> -->
              <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;">退费时间</div>
              <div style="width: 2250px; padding-top: 20px;">
                <el-date-picker style=" width: 25%; margin-left: 10px;" :disabled="allIsUpdate === 1" v-model="PaymentTime" value-format="yyyy-MM-dd" type="date"  size="small" :clearable="false" placeholder="选择退费时间"></el-date-picker>
              </div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
              <!-- <span style="position: absolute;  margin-top: 18px;  color: red;">*</span> -->
              <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;">退费渠道</div>
              <div style="width: 2250px; padding-top: 20px;">
                <el-select style="width: 25%; margin-left: 10px;"  :disabled="allIsUpdate === 1" filterable :clearable="false"  v-model="Paymentchannel" size="small"  placeholder="请选择退费渠道">
                  <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </div>
            </div>

            <div style="width: 100%;border-bottom: 1px solid #ccc; height: 60px;display: flex; "> 
              <!-- <span style="position: absolute;  margin-top: 18px;  color: red;">*</span> -->
              <div style="width: 131px; text-align: center;padding-top: 20px;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;">退费截图</div>
              <div style="width: 2250px; padding: 15px 0px; display: flex; ">
                <el-button size="small" style=" margin-left: 10px;"  :disabled="allIsUpdate === 1" type="primary" class="btns" @click="handleUpload('全款')">点击上传</el-button>
                <div v-if="chargeCollectionPicture.length > 0" style="display: flex;"> 
                  <div v-for="(item,index) in chargeCollectionPicture" :key="index" >
                    <img :src="item.url" :alt="item.name"  style="width: 50px; height: 50px; margin-left: 10px;margin-top: -7px;" >
                    <span v-if="item" @click="handleView(item.url,item.width,item.height)" style="color: #0999e1;margin-left: 10px;">预览</span>
                    <span v-if="item" @click="handleViews(chargeCollectionPicture,index)" style="color: red;margin-left: 10px;">删除</span>
                  </div>
                </div>
              </div>
            </div>

            <div style="width: 100%;overflow: hidden;"> 
              <div style="display: flex; ">
                <div style="height: 136px;width: 131px; text-align: center;font-size: 13px;font-weight: 900; border-right: 1px solid #ccc;padding-top: 55px;">备注原因</div>
                <div style="width: 2250px; padding: 0px 0px 15px 0px; display: flex; ">

                      <div class="init-b" v-if="allIsUpdate === 1">
                              <div style="border-bottom: 1px solid #c7c3c3;width: 98%; margin-top: 5px;" v-for="(itme,index) in doubtContent" :key="index">
                                <div v-if="itme.commitContent">老师：{{ itme.commitContent }}</div>
                                <div v-if="itme.teacherName">提交人：{{ itme.teacherName }}</div>
                                <div v-if="itme.remark">备注：{{ itme.remark }}</div>
                                <div v-if="itme.auditName">审核人：{{ itme.auditName }}</div>
                                <div v-if="itme.remarkDate">提交时间：{{ itme.remarkDate }}</div>
                              </div>
                      </div>
                      <div style="width: 45%;margin-left: 10px; margin-top: 15px;" v-else>
                        <el-input resize="none"  type="textarea"  :autosize="{  minRows: 4, maxRows: 4 }"  v-model="chengRemarksssss"> </el-input>
                      </div>


                      <!-- <div style="width: 90px;  margin-left: 22px;   text-align: center;  font-size: 13px;  font-weight: 900;  border-right: 1px solid rgb(204, 204, 204);  padding-top: 50px;  border-left: 1px solid rgb(204, 204, 204);">审批人</div>
                      <div style="width: 45%;margin-left: 10px; margin-top: 15px;">
                        <el-select v-model="ApprovalPeople" size="small" :disabled="allIsUpdate === 1" style="width: 50%;" placeholder="请选择审批人">
                          <el-option v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
                        </el-select>
                      </div> -->
                </div>
              </div>
              <div style="width: 97%; text-align: end; margin-top: -90px; ">
                  <el-button size="small"  type="primary"  :disabled="allIsUpdate === 1"  @click="handleViewSet('退费','','customerInformationCollectionAudit/updateReturn',chengRemarksssss,ApprovalPeople, { PaymentTime, Paymentchannel, chargeCollectionPicture })" style="margin-left: 10px;">提交审批</el-button>
              </div> 
            </div>


          </div>
        </div>


        <!-- <el-form-item  v-if="isCustomerStatus === 1 && isClassType === 1" label="退费金额：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="AcademicExpenses" autocomplete="off" size="small" placeholder="请输入退费金额"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 1  && isClassType === 1" label="退费时间：" style="margin-left: 80px;">
          <el-date-picker v-model="PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" :clearable="false" placeholder="选择退费时间"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 1  && isClassType === 1" label="退费渠道：" style="margin-left: 80px;">
          <el-select  filterable :clearable="false"  v-model="Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择退费渠道">
                <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 1  && isClassType === 1" label="诊断课：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="AcademicClasses" autocomplete="off" size="small" placeholder="请输入诊断课"></el-input>
        </el-form-item>



        <el-form-item  v-if="isCustomerStatus === 1 && isClassType === 3" label="退费金额：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="AcademicExpenses" autocomplete="off" size="small" placeholder="请输入退费金额"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 1  && isClassType === 3" label="退费时间：" style="margin-left: 80px;">
          <el-date-picker v-model="PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" :clearable="false" placeholder="选择退费时间"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 1  && isClassType === 3" label="退费渠道：" style="margin-left: 80px;">
          <el-select  filterable :clearable="false"  v-model="Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择退费渠道">
                <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 1  && isClassType === 3" label="学业课：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
        </el-form-item>




        <el-form-item  v-if="isCustomerStatus === 2 && isClassType === 1" label="规划费：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="Plan" autocomplete="off" size="small" placeholder=""></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2 && isClassType === 1" label="学业费：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2  && isClassType === 1" label="学业课：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2  && isClassType === 1" label="家庭教育费：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="FamilyEducationExpenses" autocomplete="off" size="small" placeholder="请输入家庭教育费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2  && isClassType === 1" label="家庭教育课：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="FamilyEducationClass" autocomplete="off" size="small" placeholder="请输入家庭教育课"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2  && isClassType === 1" label="伴读费：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="AccompanyingReadingFee" autocomplete="off" size="small" placeholder="请输入伴读费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2  && isClassType === 1" label="伴读：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="AccompanyingReading" autocomplete="off" size="small" placeholder="伴读"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2  && isClassType === 1" label="远程路补：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="RemoteRoadRepair" autocomplete="off" size="small" placeholder="远程路补"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2  && isClassType === 1" label="退费时间：" style="margin-left: 80px;">
          <el-date-picker v-model="PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" :clearable="false" placeholder="选择退费时间"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2  && isClassType === 1" label="退费渠道：" style="margin-left: 80px;">
          <el-select  filterable :clearable="false"  v-model="Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择退费渠道">
                <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        


        <el-form-item  v-if="isCustomerStatus === 2  && isClassType === 3" label="学业费：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="AcademicExpenses" autocomplete="off" size="small" placeholder="请输入学业费"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2  && isClassType === 3" label="学业课：" style="margin-left: 80px;">
          <el-input :clearable="false" v-model="AcademicClasses" autocomplete="off" size="small" placeholder="请输入学业课"></el-input>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2  && isClassType === 3" label="退费时间：" style="margin-left: 80px;">
          <el-date-picker v-model="PaymentTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small" :clearable="false" placeholder="选择退费时间"></el-date-picker>
        </el-form-item>
        <el-form-item  v-if="isCustomerStatus === 2  && isClassType === 3" label="退费渠道：" style="margin-left: 80px;">
          <el-select  filterable :clearable="false"  v-model="Paymentchannel" size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择退费渠道">
                <el-option v-for="item in payTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->



        <el-form-item label="是否继续上课">
          <el-select  v-model="isWantToContinueTheClass" filterable  :clearable="false" style="width: 100%;" placeholder="请选择是否继续上课" @change="changeisWantToContinueTheClass">
            <el-option v-for="item in isThereARefundList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

      <!--   <el-form-item style="" label="审批人">
          <el-select v-model="ApprovalPeople" size="small" style="width: 100%;" placeholder="请选择审批人">
              <el-option v-for="item in optionList2"  :key="item.id"  :value="item.id" :label="item.realname"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="备注">
            <el-input v-model="chengRemarks" :autosize="{ minRows: 6, maxRows: 6 }" type="textarea"  placeholder="请输入备注" maxlength="300" show-word-limit></el-input>
        </el-form-item> -->


      </div>



    </el-form>


    <div class="dialog-footer" style="text-align: end;padding-top: 30px;">
       <div style="text-align: end;">
         <el-button size="small" @click="closeEditDialog">取 消</el-button>
         <el-button size="small" :disabled="loginStb" type="primary" @click="saveEditForm"  v-if="typeCustomerFunding != '定金' &&!isDetail">确 定</el-button>
         <el-button size="small" :disabled="loginStb" type="primary" @click="saveEditForm1"  v-if="typeCustomerFunding === '定金' && !isDetail">确 定</el-button>
       </div>
    </div>

  </el-dialog>




  <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" title="原因"  :visible="isOrderStatus" :before-close="closeisOrderStatus" width="50%">
          <el-input v-model="isOrderStatusTextarea"
          type="textarea"
          :autosize="{ minRows: 8, maxRows: 8 }"
          show-word-limit
          maxlength="9999999"
          placeholder="请输入原因"></el-input>
          <div class="dialog-footer" style="text-align: end;padding-top: 30px;">
            <div style="text-align: end;">
              <el-button size="small" @click="isOrderStatus = false, isOrderStatusTextarea = ''">取 消</el-button>
              <el-button size="small" type="primary" @click="isOrderStatus = false">确 定</el-button>
            </div>
          </div>
  </el-dialog>



  <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" title="添加/修改课时方案"  :visible="isToLong" :before-close="closeisisToLong" width="50%">
          
          <div style="display: flex;">
            <div style="padding-top: 9px;margin-left: 10px;">签约课时方案：</div>
            <div style="width: 80%;">
              <el-select  filterable  v-model="contractScheme" clearable size="small" style="margin-top: 5px;width: 100%;" placeholder="请选择签约课时方案">
                 <el-option v-for="item in payTypessss" :key="item.id" :label="item.signContractName" :value="item.id"></el-option>
              </el-select>
            </div>
          </div>

          <div style="display: flex; margin: 15px 0px; ">
            <div style="padding-top: 9px;margin-left: 10px;">签约开始时间：</div>
            <div style="width: 80%;">
              <el-date-picker v-model="contractTime" value-format="yyyy-MM-dd" type="date" style="width: 100%"  size="small"  placeholder="选择签约开始时间"></el-date-picker>
            </div>
          </div>


          <div class="dialog-footer" style="text-align: end;padding-top: 30px;">
            <div style="text-align: end;">
              <el-button size="small" type="primary" @click="closeisisToSbut">确 定</el-button>
              <el-button size="small" @click="closeisisToLong">取 消</el-button>
            </div>
          </div>

  </el-dialog>



  <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false" title="历史记录"  :visible="isToView" :before-close="closeisisToView" width="50%">

          <div style="padding-top: 9px;margin-left: 10px; overflow-y: auto;height: 500px;" v-if="GetListView.length > 0">
              <div v-for="(itme,index) in GetListView" :key="index" style="margin: 30px 0px;"> 
                  <div style="margin:10px 0px;">创建时间: {{ itme.createTime }}</div>
                  <div style="margin:10px 0px;">{{ index === GetListView.length - 1 ? '创建人' : '修改人'}}: {{ itme.createName }}</div>
                  <div style="margin:10px 0px;">课时签约包: {{ itme.signContractName }}</div>
                  <div style="margin:10px 0px;">签约时间: {{ itme.periodStartTime }}  -  {{ itme.periodEndTime }}</div>
              </div>
          </div>

          <div v-else>
            <el-empty description="暂无数据"></el-empty>
          </div>

          <div class="dialog-footer" style="text-align: end;padding-top: 30px;">
            <div style="text-align: end;">
              <el-button size="small" @click="closeisisToView">取 消</el-button>
            </div>
          </div>

  </el-dialog>




  <Elupload
   v-if="isShowElupload"
   @handleEventElUpload="handleEventElUpload"
   @handleEventElUploadSubt="handleEventElUploadSubt"
   :Uploadtypes="Uploadtypes"
   :fileAllLists="fileAllLists"

   :chargeCollectionPicture="chargeCollectionPicture"
   :renewalCollectionListWay="renewalCollectionListWayIndexList"

   :isTpyeImg="isTpyeImg"
   :isTypeListRow="isTypeListRow"
   :isTypeListindex="isTypeListindex"

  ></Elupload>




  <el-dialog class="my-dialog" :center="true" modal-append-to-body append-to-body :close-on-click-modal="false"   :visible="isImg" :before-close="closeisImg" width="80%">
          <img  :src="isImgs" :alt="isImgs" :style="{ width: imgWidth ? imgWidth + 'px' : '100%', height: imgHeight ? imgHeight + 'px' : '550px', margin: '10px', }">
          <!-- <img  :src="isImgs" :alt="isImgs" style="width: 100%; height: 550px; margin: 10px;" > -->
          <div class="dialog-footer" style="text-align: end;padding-top: 30px;">
            <div style="text-align: end;">
              <el-button size="small" @click="closeisImg">取 消</el-button>
            </div>
          </div>
  </el-dialog>


  <el-dialog :center="true" modal-append-to-body append-to-body :close-on-click-modal="false"   :visible="handlecustomerAccountName111Sahow" :before-close="handlecustomerAccountName111Sahowcloseis" width="40%">
          <div>保存规划师吗?</div>
          <div class="dialog-footer" style="text-align: end;padding-top: 30px;">
            <div style="text-align: end;">+
              <el-button size="small" type="primary" @click="handlecustomerAccountName111Sahowcloseiss">保存</el-button>
              <el-button size="small"  @click="handlecustomerAccountName111Sahowcloseis">取消</el-button>
            </div>
          </div>
  </el-dialog>




 </div>
</template>



<script>
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  import Elupload from "./Elupload.vue";

  export default {
    components: {
      Elupload,
    },
    props: {
      typeCustomerFunding:{
        default: "",
        type: String,
      },
      isUrView:{
        default: "",
        type: String,
      },
    },
    data() {
      return{ 

        loginStb:false,
        ListDataLngLat:[],

        xxxxx: 0,

        isOrderStatusShow: 0,

        orderSaleId:'',

        doubtContent:[],

        imgWidth: 0,
        imgHeight: 0,

        GetListView:[
         
        ],

        handlecustomerAccountName111Sahow:false,

        customerAccountName11: '',
        customerAccountName111: '',
        optionsList111: [],
        optionsList1111: [],

        isImg:false,
        isImgs:'',

        textareaJson: [],
        newTextareaJson: '',


        isShowElupload: false,
        renewalCollectionListWayIndexList: [],

        isCustomsDeclarationchengRemarks: '',

        isCustomerStatus: '',

        teacherss: [{id:1,name:'规划'},{id:3,name:'纯补课'},{id:2,name:'线下'}],

        chengRemarksssss:'',


        optionOrderStatus: [{id:0,name:'待成单'},{id:1,name:'已成单'},{id:2,name:'未成单'},{id:3,name:'已退费'}],

        isOrderStatus: false,
        typessssssss: '',


        paymentAmount: '',
        paymentAmountTime: '',
        paymentAmountChannel: '',
        paymentAmountCourse: '',

        DiagnosticClass : '',
        DiagnosticClassFee  : '',
        DiagnosticClassFeeGift  : '',



        isClassType: '',

        contractScheme: '',
        contractTime: '',



        optionsListt:[
          {dictValue:"北京", dictType:1 },
          {dictValue:"深圳", dictType:2 },
          {dictValue:"深圳", dictType:3 },
        ],

        optionsList:[],

        newaddress:'',
        detailedAddress:'',
        remarks:'',

        searchResults: [],

        contractAmount: '',

        allIsUpdate:'',

        OrderStatus: 0,

        chengRemarks:'',
        ApprovalPeople: 63,
        optionList2:[],

        isreturnPremium: false,

        classTypes_s: [{ value: 1, label: '在读' }, { value: 2, label: '结业' }, { value: 3, label: '停课' },{ value: 4, label: '流失' }],

        payTypeLsit: [{ value: 1, label: '诊断课' }, { value: 2, label: '学业课' }, { value: 3, label: '学习力课' },{ value: 4, label: '学生个案' },{ value: 5, label: '家长个案' },{ value: 6, label: '伴读' }],
        customerHourType:'',
        customerHour:'',

        checked: false,
        checked1: false,
        expireTimeOption: {
          disabledDate (date) {
            //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
            return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
          }
        },
        // time: '6:00',//钟表时间
        categoryList: [], //课程集合
        orderType: [
          {
            value: 1,
            label: '已成单'
          }, {
            value: 2,
            label: '已关单'
          },
          {
            value: 3,
            label: '已退费'
          },
        ],
        props: {
          label: "gradeName",
          children: "children",
          value: "id"
        },
        propsCategory: {
          label: "categoryName",
          children: "children",
          value: "id"
        },
        payTypes: [
          {
            value: 1,
            label: "现金"
          },
          {
            value: 2,
            label: "微信"
          },
          {
            value: 3,
            label: "支付宝"
          },
          {
            value: 4,
            label: "银行卡"
          },
          {
            value: 5,
            label: "公户"
          },
          {
            value: 6,
            label: "小鹅通"
          }
          ,{
            value: 7,
            label: "美团"
          }
           ,{
            value: 8,
            label: "公户（桑穆）"
          }
           ,{
            value: 9,
            label: "公户（博川）"
          },
          {
            value: 10,
            label: "公户（蒙正心理）"
          },
        ], // 收款渠道选项
        customer: {},

        regionName:1,

        customerId: '',
        order: {
          saleId: "", //销售id
          educationType: "", //授课方式
          classHour: "",
          familyHour: "",
          state:"",
          classType: '',
          isRenew: "2",//是否续费
          orderStatus: "",//成单状态
          remarks: "", //备注
          parentPhoneNumber: "", //家长电话
          offTeacher: "",
          OffTimeHour: "", //线下诊断时间小时
          startTimeDay: "", //诊断时间天数
          startTimeHour: "", //诊断时间小时段
          payAlltype: "",
          gradeList: [], //年级
          teacherId: "", //诊断老师id
          startTime: [], //授课时间
          payType: "", //全款付款方式
          type: "", //成交状态
          onTime: "",
          offTime: "",
          onEndTime: "", //线上结束时间
          offEndTime: "", //线下结束时间
          onlineStatus: "", //如果线上checked为true他就不为空
          offlineStatus: "", //如果线下checked为true他就不为空
          onlineTime: [], //线上诊断时间
          teacherIdOffline: "", //线下诊断教师
          teacherIdOfflineArr: [],
          teacherIdOnline: "", //线上诊断教师
          teacherIdOnlineArr: [],
          offlineTime: [], //线下诊断时间
          isDiagnosisAllPay: "", //是否交诊断费
          Lastselected: '',//取消
          diagnosisAllPayMoney: "", //诊断费用
          diagnosisTime: "", //诊断费用收款时间
          diagnosisPayType: "", //诊断费用付款方式
          allPayMoney: "", //全款费用
          payTime: "", //交全款时间
          isAllPay: "", //是否是全额尾款，分期尾款
          studentName: "", //学生姓名
          grade: [], //年级id
          sex: "", // 性别
          address: "", //家庭地址
          regionName:1,
          studentId: "", //学生ID
          courseCategoryIds: [], //课程id
          customerInformationId: "", //客资id
          renews: [
            {
              renewType: "",//续费方式
              renewTime: "",//续费时间
              renewMoney: "",//续费金额
              classHourRenew: "",
              familyHourRenew: "",
            }
          ],
          stages: [
            {
              stagesMoney: "", // 分期金额
              stagesDate: "", // 分期时间
              payType: "", // 收款渠道
              agingClassHour: "",
              agingFamilyHour: ""
            }
          ]
        },
        customerAccountName: "",
        classTypsArr: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],
        showEdit: false,
        rules: {
            studentName: [
              {
                required: true,
                message: "请输入学生名称",
                trigger: "blur"
              }
            ],
            grade: [
              {
                required: true,
                message: "请选择年级",
                trigger: "change"
              }
            ],
            sex: [{ required: true, message: "请选择性别", trigger: "change" }],
            address: [
              {
                required: true,
                message: "请输入家庭住址",
                trigger: "blur"
              }
            ],
            parentPhoneNumber: [
              {
                required: true,
                message: "请输入家长电话",
                trigger: "blur"
              },
              { type: "number", message: "家长电话必须为数字值" }
            ],
            courseCategoryIds: [
              { required: true, message: "请选择课程类别", trigger: "change" }
            ],
            teacherId: [
              { required: true, message: "请选择授课教师", trigger: "change" }
            ],
            startTime: [
              { required: true, message: "请选择授课时间", trigger: "change" }
            ]
          },


          isOrderStatusTextarea:'',

          teachers: [
            {
              value: 1,
              label: "小单老师",
            },
            {
              value: 2,
              label: "大单老师",
            },
            {
              value: 3,
              label: "刘老师",
            },
            {
              value: 4,
              label: "杨老师",
            },
          ],


          isThereAChargeList: [{id:1,name:'是'},{id:2,name:'否'}],
          isThereACharge:'',
          isThereACharge1:'',


          renewalCollectionListWay:[
            // {
            //   AcademicExpenses:'',
            //   AcademicClasses:'',
            //   FamilyEducationExpenses:'',
            //   FamilyEducationClass:'',
            //   AccompanyingReadingFee:'',
            //   AccompanyingReading:'',
            //   RemoteRoadRepair:'',
            //   PaymentTime:'',
            //   Paymentchannel:'',
            //   classGiveHour:'', 
            //   familyGiveHour:'',
            //   readingGiveHour:'',
            //   DiagnosticClass : '',
            //   DiagnosticClassFee : '',
            //   DiagnosticClassFeeGift : '',
            //   chargeCollectionPicture: [],
            // }
          ],

          chargeCollectionPicture: [],

          Plan:'',
          diagnoseMoney : '',
          diagnoseHour  : '',
          diagnoseGiveHour  : '',

          studentMoney: '',
          studentHour: '',
          studentGiveHour: '',

          patriarchMoney: '',
          patriarchHour: '',
          patriarchGiveHour: '',

          AcademicExpenses:'',
          AcademicClasses:'',
          FamilyEducationExpenses:'',
          FamilyEducationClass:'',
          AccompanyingReadingFee:'',
          AccompanyingReading:'',
          PaymentTime:'',
          Paymentchannel:'',
          RemoteRoadRepair:'',

          classGiveHour:'', 
          familyGiveHour:'',
          readingGiveHour:'',


          RemoteRoadRepairClass:'',
          RemoteRoadRepairGiveHour:'',



          isYouWantToRenewList: [{id:1,name:'是'},{id:2,name:'否'}],
          isYouWantToRenew:'',




          renewalCollectionList:[
            {
              AcademicExpenses:'',
              AcademicClasses:'',
              FamilyEducationExpenses:'',
              FamilyEducationClass:'',
              AccompanyingReadingFee:'',
              AccompanyingReading:'',
              RemoteRoadRepair:'',
              PaymentTime:'',
              Paymentchannel:'',
              classGiveHour:'', 
              familyGiveHour:'',
              readingGiveHour:'',
              DiagnosticClass : '',
              DiagnosticClassFee : '',
              DiagnosticClassFeeGift : '',
              renewCollectionPicture:[],
            }
          ],


          isTypeListRow: [],

          isProject : 0,

          isThereARefundList: [{id:1,name:'是'},{id:2,name:'否'}],
          isThereARefundList1: [{id:1,name:'是'},{id:2,name:'否'}],

          isThereARefundListt: [{id:1,name:'是'},{id:0,name:'否'}],  

          isThereARefund:'',


          isWantToContinueTheClass:'',

          isCustomsDeclaration: 2,


          isDetail: false,

          infoObj: {},


          fileAllLists: [],
          Uploadtypes: '',


          isTypeListRow: [],
          isTpyeImg: false,

          setWay: '全款',

          isTypeListindex: 0,

          isUpdate:0,



          isToView:false,
          isToLong:false,

          payTypessss: [],

          statusId:'',

       
      }
    },


    mounted () {
      this.getGrade();
      this.getTeachers();
      this.getCategoryList();

      this.optionsList1111 = JSON.parse(sessionStorage.getItem('projectTeacherFindList'))
      this.optionsList111 = JSON.parse(sessionStorage.getItem('diagnoseTeacherFindList'))
      this.payTypes = JSON.parse(sessionStorage.getItem('payTypesList'))

      axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{
        this.optionsListt = res.data.data
      })

      axios.get(`${apiBaseUrl}/orderCustomerAudit/findAuditList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
        this.optionList2 = res.data.data
      })


      axios.get(`${apiBaseUrl}/sign_contract/findByList`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')} }) .then(res => {
          if(res.data.code === 200){
              if(res.data.data && res.data.data.length > 0){
                this.payTypessss = res.data.data
              }else{
                this.payTypessss = []
              }
          }else{
            this.payTypessss = []
          }
      })



      // .clock-picker__input-container{
      //   background: #f3f3f3 !important;
      // }

      this.optionsList = JSON.parse(sessionStorage.getItem('customersaleObj'))


    },

    methods: {

      handleDateChange(){
        console.log('handleDateChange:',this.order.offTime);
         if(this.order.offTime){
            if(this.order.teacherIdOfflineArr && this.order.teacherIdOfflineArr.length > 0){
               let data = { courseDate: this.order.offTime, teacher_id: this.order.teacherIdOfflineArr.join(',') }
               axios.post(`${apiBaseUrl}/attendanceWXTeacher/queryTeacherLeave`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                if (res.data.code === 200) {
                    if(res.data.data && res.data.data.length > 0){
                      let len = res.data.data[0]
                      this.$message.warning(len)
                    }
                } else {
                  this.$message.error('请联系管理员~');
                }
              }).catch(err => {
                this.$message.error(err,'请联系管理员~');
              })
            }
        }
      },

      handleGetTeacher(){
        if(this.order.offTime){
            if(this.order.teacherIdOfflineArr && this.order.teacherIdOfflineArr.length > 0){
               let data = { courseDate: this.order.offTime, teacher_id: this.order.teacherIdOfflineArr.join(',') }
               axios.post(`${apiBaseUrl}/attendanceWXTeacher/queryTeacherLeave`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                if (res.data.code === 200) {
                    if(res.data.data && res.data.data.length > 0){
                      let len = res.data.data[0]
                      this.$message.warning(len)
                    }
                } else {
                  this.$message.error('请联系管理员~');
                }
              }).catch(err => {
                this.$message.error(err,'请联系管理员~');
              })
            }
        }
      },

      handleViews(list,index) {
         list.splice(index, 1)
      },

      handleautocompleteClears(item,index) {
        console.log('handleautocompleteClears:', item,index);
        item.latitude = ''
        item.precisionLng = ''
        item.city = ''
        item.remarks = ''
        item.detailedAddress = ''
        item.newaddress = ''
        item.precisionLng = ''
        item.city = ''
        item.latitude = ''
        item.value = ''
        item.district = ''
        item.addressTitleName = ''
        item.addressFollow = ''
        item.districtName = ''
        item.address = ''
      },

      handleSelects(item,event) {
        console.log('用户选择了handleSelects:', item,event);
        item.latitude = event.latitude
        item.precisionLng = event.precisionLng
        item.city = event.city
        item.newaddress = event.value
        item.precisionLng = event.precisionLng 
        item.city = event.city
        item.latitude = event.latitude
        item.value = event.value
        item.district = event.district
        item.addressTitleName = event.addressTitleName
        item.addressFollow = event.addressFollow
        item.districtName = event.districtName
        item.address = event.address
      },

      async querySearchAsyncs(queryString, cb) {
        if (!queryString) {
          cb([]);
          return;
        }

        // 模拟调用后端接口获取数据
        const results = await this.fetchAddressesFromBackends(queryString);

        // 调用回调函数，传递搜索结果
        cb(results);
      },

      // 模拟后端接口请求
      fetchAddressesFromBackends(query) {
        return new Promise((resolve, reject) => {
              let dateObj = {
                regionName: this.xxxxx === 1 ? '北京' : this.xxxxx === 2 ? '深圳' : this.xxxxx === 3 ? '上海' : this.xxxxx === 4 ? '广州' : '',
                keyword: query
              }
              axios.post(`${apiBaseUrl}/student/getSiteInfoList`, dateObj,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                if (res.data.code === 200) {
                  console.log(res.data.data, '获取地址列表')
                  resolve(res.data.data.map(item => ({
                        value: item.addressTitleName,
                        city: item.districtName,
                        district: item.addressFollow,
                        addressTitleName: item.addressTitleName,
                        addressFollow: item.addressFollow,
                        districtName: item.districtName,
                        address: item.addressFollow,
                        latitude: item.latitude,
                        precisionLng: item.precisionLng,
                  })));
                } else {
                  this.$message.error('检查网络，或选择所属地域~');
                  resolve([]);
                }
              }).catch(err => {
                this.$message.error(err,'检查网络，请联系管理员~');
                reject(new Error('JSONP请求失败'));
              })
          })

      },

      handleClears(itme) {
        console.log('Selected value:', itme);
        this.xxxxx = itme.regionName
        itme.remarks = ''
        itme.detailedAddress = ''
        itme.newaddress = ''
        itme.precisionLng = ''
        itme.city = ''
        itme.latitude = ''
        itme.value = ''
        itme.district = ''
        itme.addressTitleName = ''
        itme.addressFollow = ''
        itme.districtName = ''
        itme.address = ''

      },

      handleAdd(){
        this.ListDataLngLat.push({
          regionName:'',
          newaddress:'',
          detailedAddress:'',
          remarks:'',
          latitude:'',
          city:'',
          value: '',
          city: '',
          district: '',
          addressTitleName: '',
          addressFollow: '',
          districtName: '',
          address: '',
          precisionLng: '',
        })
      },

      handleRemove(){
        this.ListDataLngLat.pop()
      },


      handleViewSet(type, index, url, Remark, People, { PaymentTime, Paymentchannel, chargeCollectionPicture, AcademicExpenses } ){

        

        if(this.isClassType === 1 && this.typeCustomerFunding != '退费'){

            if(this.contractScheme && this.contractTime){

                if(PaymentTime && Paymentchannel && chargeCollectionPicture.length > 0){

                    let newObj = {} 

                    if(type === '全款'){
                        newObj = {
                                      classType: this.isClassType ? this.isClassType : '',
                                      customerId: this.customerId,
                                      projectMoney: this.Plan ? this.Plan  : '',
                                      allPayMoney: this.AcademicExpenses ? this.AcademicExpenses  : '',
                                      classHour: this.AcademicClasses ? this.AcademicClasses  : '',
                                      familyHour: this.FamilyEducationClass ? this.FamilyEducationClass  : '',
                                      familyMoney: this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : '',
                                      readingPartnerMoney: this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : '',
                                      readingPartnerHour: this.AccompanyingReading ? this.AccompanyingReading  : '',
                                      
                                      wayMoney: this.RemoteRoadRepair ? this.RemoteRoadRepair  : '',
                                      payTime: this.PaymentTime ? this.PaymentTime  : '',
                                      payAlltype: this.Paymentchannel ? this.Paymentchannel  : '',
                                      
                                      classGiveHour: this.classGiveHour ? this.classGiveHour  : '',
                                      familyGiveHour: this.familyGiveHour ? this.familyGiveHour  : '',
                                      readingGiveHour: this.readingGiveHour ? this.readingGiveHour  : '',
                                      
                                      stages: JSON.stringify([]),

                                      isAllPay: this.isThereACharge ? this.isThereACharge : '',
                                      isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                                      isReturnPremium: this.isThereARefund ? this.isThereARefund : '',

                                      auditId: People ? People : '',
                                      commitRemark: Remark ? Remark : '',

                                      isClose: this.isCustomsDeclaration,
                                      closeCause: this.isCustomsDeclarationchengRemarks,


                                      projectMoney: this.Plan,
                                      diagnoseMoney: this.diagnoseMoney,
                                      diagnoseHour: this.diagnoseHour,
                                      diagnoseGiveHour: this.diagnoseGiveHour,
                                      studentMoney: this.studentMoney,
                                      studentHour: this.studentHour,
                                      studentGiveHour: this.studentGiveHour,
                                      patriarchMoney: this.patriarchMoney,
                                      patriarchHour: this.patriarchHour,
                                      patriarchGiveHour: this.patriarchGiveHour,
                                      chargeCollectionPicture: this.chargeCollectionPicture.length > 0 ? JSON.stringify(this.chargeCollectionPicture) : JSON.stringify([]),

                                      collectionType: this.setWay === '全款' ? 1 : this.setWay === '分期' ? 2 : '',
                                      isProject: this.isProject,
                                      contractCost: this.contractAmount,

                                      projectTeacherId: this.customerAccountName111,
                                      diagnoseTeacherId: this.customerAccountName11,

                                      classMoney: this.AcademicExpenses,
                                      chargeCollectionDate: this.PaymentTime,
                                      customerIsallpay: this.isThereACharge,

                        }
                    }



                    if(type === '分期'){
                      let obj = {}
                      let AcademicExpensess = AcademicExpenses
                      let PaymentTimes = PaymentTime
                      this.renewalCollectionListWay.map((itme,indexs)=>{
                                  if(index === indexs){
                                      obj = {
                                        
                                            customerId: this.customerId,
                                            periodsNumber: index + 1,
                                            projectMoney: itme.Plan || '',
                                            diagnoseMoney: itme.diagnoseMoney || '',
                                            customerAllpaymoney: itme.AcademicExpenses || '',
                                            familyMoney: itme.FamilyEducationExpenses || '',
                                            patriarchMoney: itme.patriarchMoney || '',
                                            studentMoney: itme.studentMoney || '',
                                            wayMoney: itme.AccompanyingReadingFee || '',
                                            readingPartnerMoney: itme.RemoteRoadRepair || '',
                                            stagesDate:itme.PaymentTime || '',
                                            payType: itme.Paymentchannel || '',
                                            stagesPicture: itme.chargeCollectionPicture ? JSON.stringify(itme.chargeCollectionPicture) : JSON.stringify([]),
                                            chargeCollectionPicture: itme.chargeCollectionPicture ? JSON.stringify(itme.chargeCollectionPicture) : JSON.stringify([]),
                                            diagnoseHour: itme.diagnoseHour,
                                            diagnoseGiveHour: itme.diagnoseGiveHour,
                                            studentHour: itme.studentHour,
                                            studentGiveHour: itme.studentGiveHour,
                                            patriarchHour: itme.patriarchHour,
                                            patriarchGiveHour: itme.patriarchGiveHour,
                                            classHour: itme.AcademicClasses ? itme.AcademicClasses  : '',
                                            familyHour: itme.FamilyEducationClass ? itme.FamilyEducationClass  : '',
                                            readingPartnerHour: itme.AccompanyingReading ? itme.AccompanyingReading  : '',
                                            payTime: itme.PaymentTime ? itme.PaymentTime  : '',
                                            payAlltype: itme.Paymentchannel ? itme.Paymentchannel  : '',
                                            classGiveHour: itme.classGiveHour ? itme.classGiveHour  : '',
                                            familyGiveHour: itme.familyGiveHour ? itme.familyGiveHour  : '',
                                            readingGiveHour: itme.readingGiveHour ? itme.readingGiveHour  : '',
                                            auditId: People ? People : '',
                                            commitRemark: Remark ? Remark : '',
                                              

                                            classMoney: AcademicExpensess,
                                            chargeCollectionDate: PaymentTimes,
                                            customerIsallpay: this.isThereACharge,

                                    } 
                                }
                      })



                      let newObjAll = {
                                  classType: this.isClassType ? this.isClassType : '',
                                  isAllPay: this.isThereACharge ? this.isThereACharge : '',
                                  isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                                  isReturnPremium: this.isThereARefund ? this.isThereARefund : '',
                                  auditId: this.ApprovalPeople ? this.ApprovalPeople : '',
                                  commitRemark: this.chengRemarks ? this.chengRemarks : '',
                                  isClose: this.isCustomsDeclaration,
                                  closeCause: this.isCustomsDeclarationchengRemarks,
                                  collectionType: this.setWay === '全款' ? 1 : this.setWay === '分期' ? 2 : '',
                                  isProject: this.isProject,
                                  contractCost: this.contractAmount,
                                  projectTeacherId: this.customerAccountName111,
                                  diagnoseTeacherId: this.customerAccountName11,
                                  customerId: this.customerId,
                                  auditId: People ? People : '',
                                  commitRemark: Remark ? Remark : '',
                      }

                      newObj = Object.assign({}, obj, newObjAll);

                    }



                    if(type === '续费'){

                      let newStringObj = {}
                      this.renewalCollectionList.map((itme,indexs)=>{
                            if(index === indexs){
                                newStringObj = {
                                    customerId: this.customerId,
                                    projectMoney: itme.Plan,
                                    renewMoney: itme.AcademicExpenses || '',
                                    classHourRenew: itme.AcademicClasses || '',
                                    familyMoney: itme.FamilyEducationExpenses || '',
                                    familyHourRenew: itme.FamilyEducationClass || '',
                                    readingPartnerMoney: itme.AccompanyingReadingFee || '',
                                    readingPartnerHour: itme.AccompanyingReading || '',
                                    wayMoney: itme.RemoteRoadRepair || '',
                                    renewTime: itme.PaymentTime || '',
                                    renewType: itme.Paymentchannel || '',
                                    classGiveHour: itme.classGiveHour || '',
                                    familyGiveHour: itme.familyGiveHour || '',
                                    readingGiveHour: itme.readingGiveHour || '',
                                    diagnoseHour: itme.diagnoseHour || '',
                                    diagnoseMoney: itme.diagnoseMoney || '',
                                    diagnoseGiveHour: itme.diagnoseGiveHour || '',
                                    patriarchHour: itme.patriarchHour || '',
                                    patriarchGiveHour: itme.patriarchGiveHour || '',
                                    patriarchMoney: itme.patriarchMoney || '',
                                    studentHour: itme.studentHour || '',
                                    studentGiveHour: itme.studentGiveHour || '',
                                    studentMoney: itme.studentMoney || '',
                                    chargeCollectionPicture: chargeCollectionPicture && chargeCollectionPicture.length > 0 ? JSON.stringify(chargeCollectionPicture) : JSON.stringify([]),
                                    projectTeacherId: this.customerAccountName111,
                                    diagnoseTeacherId: this.customerAccountName11,
                                    auditId: People ? People : '',
                                    payAlltype: Paymentchannel || '',
                                    chargeCollectionDate: PaymentTime || '',
                                    commitRemark: Remark ? Remark : '',
                                    isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                                    periodsNumber: index + 1,
                                    classMoney: itme.AcademicExpenses || '',
                                    classHour: itme.AcademicClasses || '',

                                }
                            }
                      })

                      newObj = newStringObj
                    }


                    if(type === '退费'){
                        newObj = {
                            classType: this.isClassType || '',
                            customerReturnType: this.isWantToContinueTheClass || '',
                            projectTeacherId: this.customerAccountName111,
                            diagnoseTeacherId: this.customerAccountName11,
                            projectMoney: this.Plan || '',
                            returnPremiumPrice: this.AcademicExpenses || '',
                            returnPremiumHour: this.AcademicClasses || '',
                            familyMoney: this.FamilyEducationExpenses || '',
                            familyHourRenew: this.FamilyEducationClass || '',
                            readingPartnerMoney: this.AccompanyingReadingFee || '',
                            readingPartnerHour: this.AccompanyingReading || '',
                            wayMoney: this.RemoteRoadRepair || '',
                            returnPremiumDate: this.PaymentTime || '',
                            returnPremiumPayType: this.Paymentchannel || '',
                            projectMoney: this.Plan ? this.Plan  : '',
                            allPayMoney: this.AcademicExpenses ? this.AcademicExpenses  : '',
                            classHour: this.AcademicClasses ? this.AcademicClasses  : '',
                            familyHour: this.FamilyEducationClass ? this.FamilyEducationClass  : '',
                            familyMoney: this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : '',
                            readingPartnerMoney: this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : '',
                            readingPartnerHour: this.AccompanyingReading ? this.AccompanyingReading  : '',
                            wayMoney: this.RemoteRoadRepair ? this.RemoteRoadRepair  : '',
                            payTime: this.PaymentTime ? this.PaymentTime  : '',
                            payAlltype: this.Paymentchannel ? this.Paymentchannel  : '',
                            classGiveHour: this.classGiveHour ? this.classGiveHour  : '',
                            familyGiveHour: this.familyGiveHour ? this.familyGiveHour  : '',
                            readingGiveHour: this.readingGiveHour ? this.readingGiveHour  : '',
                            projectMoney: this.Plan,
                            diagnoseMoney: this.diagnoseMoney,
                            diagnoseHour: this.diagnoseHour,
                            diagnoseGiveHour: this.diagnoseGiveHour,
                            studentMoney: this.studentMoney,
                            studentHour: this.studentHour,
                            studentGiveHour: this.studentGiveHour,
                            patriarchMoney: this.patriarchMoney,
                            patriarchHour: this.patriarchHour,
                            patriarchGiveHour: this.patriarchGiveHour,
                            chargeCollectionPicture: chargeCollectionPicture.length > 0 ? JSON.stringify(chargeCollectionPicture) : JSON.stringify([]),
                            chargeCollectionDate: PaymentTime || '',
                            isContinueType: this.isWantToContinueTheClass || '',
                            customerId: this.customerId,
                            classType: this.isClassType ? this.isClassType : '',
                            isAllPay: this.isThereACharge ? this.isThereACharge : '',
                            isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                            isReturnPremium: this.isThereARefund ? this.isThereARefund : '',
                            isClose: this.isCustomsDeclaration,
                            closeCause: this.isCustomsDeclarationchengRemarks,
                            collectionType: this.setWay === '全款' ? 1 : this.setWay === '分期' ? 2 : '',
                            isProject: this.isProject,
                            contractCost: this.contractAmount,
                            auditId: People ? People : '',
                            commitRemark: Remark ? Remark : '',
                          }
                    }


                    axios.post(`${apiBaseUrl}/${url}`, newObj,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                      if (res.data.code === 200) {
                          this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "success" });
                          this.$emit("newModesCustomerFundingDetailEvent");
                          this.$emit("refreshOrder");
                          this.showEdit = false;
                      }else{
                        this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "error" });
                      }
                    }).catch((err)=>{
                      this.$message({  message: err ,  type: "error" });
                    })

                }else{
                  this.$message({  message: '请填写必填信息~',  type: "warning" });
                }
            }else{
              this.$message({  message: '请选择签约包~',  type: "warning" });
            }
        }else{


           if(this.typeCustomerFunding === '退费'){
              let newObjs = {}
              if(type === '退费'){
                
                  newObjs = {
                      classMoney: this.AcademicExpenses,
                      classType: this.isClassType || '',
                      customerReturnType: this.isWantToContinueTheClass || '',
                      projectTeacherId: this.customerAccountName111,
                      diagnoseTeacherId: this.customerAccountName11,
                      projectMoney: this.Plan || '',
                      returnPremiumPrice: this.AcademicExpenses || '',
                      returnPremiumHour: this.AcademicClasses || '',
                      familyMoney: this.FamilyEducationExpenses || '',
                      familyHourRenew: this.FamilyEducationClass || '',
                      readingPartnerMoney: this.AccompanyingReadingFee || '',
                      readingPartnerHour: this.AccompanyingReading || '',
                      wayMoney: this.RemoteRoadRepair || '',
                      returnPremiumDate: this.PaymentTime || '',
                      returnPremiumPayType: this.Paymentchannel || '',
                      projectMoney: this.Plan ? this.Plan  : '',
                      allPayMoney: this.AcademicExpenses ? this.AcademicExpenses  : '',
                      classHour: this.AcademicClasses ? this.AcademicClasses  : '',
                      familyHour: this.FamilyEducationClass ? this.FamilyEducationClass  : '',
                      familyMoney: this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : '',
                      readingPartnerMoney: this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : '',
                      readingPartnerHour: this.AccompanyingReading ? this.AccompanyingReading  : '',
                      wayMoney: this.RemoteRoadRepair ? this.RemoteRoadRepair  : '',
                      payTime: this.PaymentTime ? this.PaymentTime  : '',
                      payAlltype: this.Paymentchannel ? this.Paymentchannel  : '',
                      classGiveHour: this.classGiveHour ? this.classGiveHour  : '',
                      familyGiveHour: this.familyGiveHour ? this.familyGiveHour  : '',
                      readingGiveHour: this.readingGiveHour ? this.readingGiveHour  : '',
                      projectMoney: this.Plan,
                      diagnoseMoney: this.diagnoseMoney,
                      diagnoseHour: this.diagnoseHour,
                      diagnoseGiveHour: this.diagnoseGiveHour,
                      studentMoney: this.studentMoney,
                      studentHour: this.studentHour,
                      studentGiveHour: this.studentGiveHour,
                      patriarchMoney: this.patriarchMoney,
                      patriarchHour: this.patriarchHour,
                      patriarchGiveHour: this.patriarchGiveHour,
                      chargeCollectionPicture: chargeCollectionPicture.length > 0 ? JSON.stringify(chargeCollectionPicture) : JSON.stringify([]),
                      chargeCollectionDate: PaymentTime || '',
                      isContinueType: this.isWantToContinueTheClass || '',
                      customerId: this.customerId,
                      classType: this.isClassType ? this.isClassType : '',
                      isAllPay: this.isThereACharge ? this.isThereACharge : '',
                      isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                      isReturnPremium: this.isThereARefund ? this.isThereARefund : '',
                      isClose: this.isCustomsDeclaration,
                      closeCause: this.isCustomsDeclarationchengRemarks,
                      collectionType: this.setWay === '全款' ? 1 : this.setWay === '分期' ? 2 : '',
                      isProject: this.isProject,
                      contractCost: this.contractAmount,
                      auditId: People ? People : '',
                      commitRemark: Remark ? Remark : '',
                    }
              }

              axios.post(`${apiBaseUrl}/${url}`, newObjs,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                if (res.data.code === 200) {
                    this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "success" });
                    this.$emit("newModesCustomerFundingDetailEvent");
                    this.$emit("refreshOrder");
                    this.showEdit = false;
                }else{
                  this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "error" });
                }
              }).catch((err)=>{
                this.$message({  message: err ,  type: "error" });
              })

           }else{
              if(PaymentTime && Paymentchannel && chargeCollectionPicture.length > 0){
                
                        let newObj = {} 

                        if(type === '全款'){
                            newObj = {
                                          classType: this.isClassType ? this.isClassType : '',
                                          customerId: this.customerId,
                                          projectMoney: this.Plan ? this.Plan  : '',
                                          allPayMoney: this.AcademicExpenses ? this.AcademicExpenses  : '',
                                          classHour: this.AcademicClasses ? this.AcademicClasses  : '',
                                          familyHour: this.FamilyEducationClass ? this.FamilyEducationClass  : '',
                                          familyMoney: this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : '',
                                          readingPartnerMoney: this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : '',
                                          readingPartnerHour: this.AccompanyingReading ? this.AccompanyingReading  : '',
                                          
                                          wayMoney: this.RemoteRoadRepair ? this.RemoteRoadRepair  : '',
                                          payTime: this.PaymentTime ? this.PaymentTime  : '',
                                          payAlltype: this.Paymentchannel ? this.Paymentchannel  : '',
                                          
                                          classGiveHour: this.classGiveHour ? this.classGiveHour  : '',
                                          familyGiveHour: this.familyGiveHour ? this.familyGiveHour  : '',
                                          readingGiveHour: this.readingGiveHour ? this.readingGiveHour  : '',
                                          
                                          stages: JSON.stringify([]),

                                          isAllPay: this.isThereACharge ? this.isThereACharge : '',
                                          isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                                          isReturnPremium: this.isThereARefund ? this.isThereARefund : '',

                                          auditId: People ? People : '',
                                          commitRemark: Remark ? Remark : '',

                                          isClose: this.isCustomsDeclaration,
                                          closeCause: this.isCustomsDeclarationchengRemarks,


                                          projectMoney: this.Plan,
                                          diagnoseMoney: this.diagnoseMoney,
                                          diagnoseHour: this.diagnoseHour,
                                          diagnoseGiveHour: this.diagnoseGiveHour,
                                          studentMoney: this.studentMoney,
                                          studentHour: this.studentHour,
                                          studentGiveHour: this.studentGiveHour,
                                          patriarchMoney: this.patriarchMoney,
                                          patriarchHour: this.patriarchHour,
                                          patriarchGiveHour: this.patriarchGiveHour,
                                          chargeCollectionPicture: this.chargeCollectionPicture.length > 0 ? JSON.stringify(this.chargeCollectionPicture) : JSON.stringify([]),

                                          collectionType: this.setWay === '全款' ? 1 : this.setWay === '分期' ? 2 : '',
                                          isProject: this.isProject,
                                          contractCost: this.contractAmount,

                                          projectTeacherId: this.customerAccountName111,
                                          diagnoseTeacherId: this.customerAccountName11,

                                          classMoney: this.AcademicExpenses,
                                          chargeCollectionDate: this.PaymentTime,
                                          customerIsallpay: this.isThereACharge,

                            }
                        }



                        if(type === '分期'){
                          let obj = {}
                          this.renewalCollectionListWay.map((itme,indexs)=>{
                                      if(index === indexs){
                                          obj = {
                                                customerId: this.customerId,
                                                periodsNumber: index + 1,
                                                projectMoney: itme.Plan || '',
                                                diagnoseMoney: itme.diagnoseMoney || '',
                                                customerAllpaymoney: itme.AcademicExpenses || '',
                                                familyMoney: itme.FamilyEducationExpenses || '',
                                                patriarchMoney: itme.patriarchMoney || '',
                                                studentMoney: itme.studentMoney || '',
                                                wayMoney: itme.AccompanyingReadingFee || '',
                                                readingPartnerMoney: itme.RemoteRoadRepair || '',
                                                stagesDate:itme.PaymentTime || '',
                                                payType: itme.Paymentchannel || '',
                                                stagesPicture: itme.chargeCollectionPicture ? JSON.stringify(itme.chargeCollectionPicture) : JSON.stringify([]),
                                                chargeCollectionPicture: itme.chargeCollectionPicture ? JSON.stringify(itme.chargeCollectionPicture) : JSON.stringify([]),
                                                diagnoseHour: itme.diagnoseHour,
                                                diagnoseGiveHour: itme.diagnoseGiveHour,
                                                studentHour: itme.studentHour,
                                                studentGiveHour: itme.studentGiveHour,
                                                patriarchHour: itme.patriarchHour,
                                                patriarchGiveHour: itme.patriarchGiveHour,
                                                classHour: itme.AcademicClasses ? itme.AcademicClasses  : '',
                                                familyHour: itme.FamilyEducationClass ? itme.FamilyEducationClass  : '',
                                                readingPartnerHour: itme.AccompanyingReading ? itme.AccompanyingReading  : '',
                                                payTime: itme.PaymentTime ? itme.PaymentTime  : '',
                                                payAlltype: itme.Paymentchannel ? itme.Paymentchannel  : '',
                                                classGiveHour: itme.classGiveHour ? itme.classGiveHour  : '',
                                                familyGiveHour: itme.familyGiveHour ? itme.familyGiveHour  : '',
                                                readingGiveHour: itme.readingGiveHour ? itme.readingGiveHour  : '',
                                                auditId: People ? People : '',
                                                commitRemark: Remark ? Remark : '',
                                                

                                                classMoney: this.AcademicExpenses,
                                                chargeCollectionDate: this.PaymentTime,
                                                customerIsallpay: this.isThereACharge,

                                        } 
                                    }
                          })



                          let newObjAll = {
                                      classType: this.isClassType ? this.isClassType : '',
                                      isAllPay: this.isThereACharge ? this.isThereACharge : '',
                                      isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                                      isReturnPremium: this.isThereARefund ? this.isThereARefund : '',
                                      auditId: this.ApprovalPeople ? this.ApprovalPeople : '',
                                      commitRemark: this.chengRemarks ? this.chengRemarks : '',
                                      isClose: this.isCustomsDeclaration,
                                      closeCause: this.isCustomsDeclarationchengRemarks,
                                      collectionType: this.setWay === '全款' ? 1 : this.setWay === '分期' ? 2 : '',
                                      isProject: this.isProject,
                                      contractCost: this.contractAmount,
                                      projectTeacherId: this.customerAccountName111,
                                      diagnoseTeacherId: this.customerAccountName11,
                                      customerId: this.customerId,
                                      auditId: People ? People : '',
                                      commitRemark: Remark ? Remark : '',
                          }

                          newObj = Object.assign({}, obj, newObjAll);

                        }



                        if(type === '续费'){

                          let newStringObj = {}
                          this.renewalCollectionList.map((itme,indexs)=>{
                                if(index === indexs){
                                    newStringObj = {
                                        customerId: this.customerId,
                                        projectMoney: itme.Plan,
                                        renewMoney: itme.AcademicExpenses || '',
                                        classHourRenew: itme.AcademicClasses || '',
                                        familyMoney: itme.FamilyEducationExpenses || '',
                                        familyHourRenew: itme.FamilyEducationClass || '',
                                        readingPartnerMoney: itme.AccompanyingReadingFee || '',
                                        readingPartnerHour: itme.AccompanyingReading || '',
                                        wayMoney: itme.RemoteRoadRepair || '',
                                        renewTime: itme.PaymentTime || '',
                                        renewType: itme.Paymentchannel || '',
                                        classGiveHour: itme.classGiveHour || '',
                                        familyGiveHour: itme.familyGiveHour || '',
                                        readingGiveHour: itme.readingGiveHour || '',
                                        diagnoseHour: itme.diagnoseHour || '',
                                        diagnoseMoney: itme.diagnoseMoney || '',
                                        diagnoseGiveHour: itme.diagnoseGiveHour || '',
                                        patriarchHour: itme.patriarchHour || '',
                                        patriarchGiveHour: itme.patriarchGiveHour || '',
                                        patriarchMoney: itme.patriarchMoney || '',
                                        studentHour: itme.studentHour || '',
                                        studentGiveHour: itme.studentGiveHour || '',
                                        studentMoney: itme.studentMoney || '',
                                        chargeCollectionPicture: chargeCollectionPicture && chargeCollectionPicture.length > 0 ? JSON.stringify(chargeCollectionPicture) : JSON.stringify([]),
                                        projectTeacherId: this.customerAccountName111,
                                        diagnoseTeacherId: this.customerAccountName11,
                                        auditId: People ? People : '',
                                        payAlltype: Paymentchannel || '',
                                        chargeCollectionDate: PaymentTime || '',
                                        commitRemark: Remark ? Remark : '',
                                        isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                                        periodsNumber: index + 1,
                                        classMoney: itme.AcademicExpenses || '',
                                        classHour: itme.AcademicClasses || '',
                                        

                                    }
                                }
                          })

                          newObj = newStringObj
                        }


                        axios.post(`${apiBaseUrl}/${url}`, newObj,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                          if (res.data.code === 200) {
                              this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "success" });
                              this.$emit("newModesCustomerFundingDetailEvent");
                              this.$emit("refreshOrder");
                              this.showEdit = false;
                          }else{
                            this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "error" });
                          }
                        }).catch((err)=>{
                          this.$message({  message: err ,  type: "error" });
                        })

              }else{
                  this.$message({  message: '请填写必填信息~',  type: "warning" });
              }
           }

           
        }

       
      },

      closeisisToView(){
        this.GetListView = []
        this.isToView = false
      },

      closeisisToLong(){
        this.init(this.customerId,this.typessssssss) 
        this.isToLong = false
      },

      closeisisToSbut(){
        let dateObj = { contractId: this.contractScheme,  periodStartTime: this.contractTime, studentId: this.statusId,  }
        axios.post(`${apiBaseUrl}/student/addStudentContract`, dateObj,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
          if (res.data.code === 200) {
              this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "success" });
              this.init(this.customerId,this.typessssssss) 
              this.isToLong = false
          }else{
            this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "error" });
          }
        }).catch((err)=>{
          this.$message({  message: err ,  type: "error" });
        })
      },
      
      handleToAdd(){
        this.isToLong = true
      },
      handleToView(){
        axios.get(`${apiBaseUrl}/student/findStudentContract/${this.statusId}`,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
            if(res.data.code === 200){
               this.GetListView = res.data.data
               this.isToView = true
            }else{
              this.GetListView = []
              this.$message({  message: res ,  type: "error" });
            }
        })
      },

      handlecustomerAccountName111Sahowcloseiss(){
        let dateObj = { customerId: this.customerId,  projectTeacherId: this.customerAccountName111 }
        axios.post(`${apiBaseUrl}/customerinformation/updateOrderProjectTeacherId`, dateObj,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
          if (res.data.code === 200) {
              this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "success" });
              this.handlecustomerAccountName111Sahow = false
          }else{
            this.$message({  message: res.data.message ? res.data.message :  res.data.meg ,  type: "error" });
            this.handlecustomerAccountName111Sahow = false
          }
        }).catch((err)=>{
          this.$message({  message: err ,  type: "error" });
        })
      },

      handlecustomerAccountName111Sahowcloseis(){
        this.handlecustomerAccountName111Sahow = false
      },

      handlecustomerAccountName111(e){
        this.handlecustomerAccountName111Sahow = true
      },

      handleSetWay (type) {
          this.setWay = type;
      },

      handleEventElUploadSubt(flileList,type, index) {

        console.log(this.renewalCollectionList)

        if  (type === '分期') {
          if (flileList && flileList.length > 0) {
              this.renewalCollectionListWay[index].chargeCollectionPicture = [...this.renewalCollectionListWay[index].chargeCollectionPicture, ...flileList]
          }
          
        }

        if  (type === '全款') {
          if (flileList && flileList.length > 0) {
              this.chargeCollectionPicture = [...this.chargeCollectionPicture, ...flileList]
          }
          
        }

        if  (type === '定金') {
         if (flileList && flileList.length > 0) {
            this.fileAllLists =  [...flileList, ...this.fileAllLists]
         }
          
        }

        if  (type === '续费') {
          if (flileList && flileList.length > 0) {
              this.renewalCollectionList[index].renewCollectionPicture =  [...this.renewalCollectionList[index].renewCollectionPicture, ...flileList]
          }
        }
 
        
        this.isShowElupload = false;
      },

      handleEventElUpload(flileList, type, index) {

        
        if  (type === '分期') {
          if (flileList && flileList.length > 0) {
              this.renewalCollectionListWay[index].chargeCollectionPicture = flileList
          }
          
        }

        if  (type === '全款') {
          if (flileList && flileList.length > 0) {
              this.chargeCollectionPicture = flileList
          }
          
        } 

        if  (type === '续费') {
          if (flileList && flileList.length > 0) {
              this.renewalCollectionList[index].renewCollectionPicture = flileList
          }
        }

        this.isShowElupload = false;
      },

      handleUploadDelet(file,index) {
        file.splice(index, 1)
      },

      handleUpload(type,index,list) {
        
       if(type === '全款'){
           this.isTpyeImg = '全款';
        }

        if(type === '分期'){
           this.renewalCollectionListWayIndexList = list ? list : []
           this.isTpyeImg = '分期';
        }

        if(type === '定金'){
           this.isTpyeImg = '定金';
        }

        if(type === '续费'){
           this.isTpyeImg = '续费';
        }

        this.Uploadtypes = type
        this.isTypeListindex = index

        this.isShowElupload = true

      },

      handleToString (num) {
        const CN_NUM = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
        const CN_UNIT = ['', '十', '百', '千'];
        const CN_SECTION = ['', '万', '亿', '万亿'];

        if (typeof num !== 'number' || isNaN(num)) return '';
        if (num < 0) {
            return '负' + handleToString(-num); // 修正：调用自己，不是 arabicToChinese
        }

        const parts = num.toFixed(2).split('.');
        const intPart = parts[0];
        const decPart = parts[1];

        let result = '';
        let zeroFlag = false;

        const sections = [];
        let temp = intPart;
        while (temp.length > 4) {
            sections.unshift(temp.slice(-4));
            temp = temp.slice(0, -4);
        }
        sections.unshift(temp.padStart(4, '0').slice(-4));

        for (let i = 0; i < sections.length; i++) {
            const section = sections[i];
            let sectionStr = '';
            zeroFlag = false;

            // 提取各位数字
            const digits = section.split('').map(d => parseInt(d));
            const [d0, d1, d2, d3] = digits; // 千、百、十、个

            // 判断是否是最高非空 section（前面没有非0节）
            const isLeadingSection = result === '';

            // 关键：处理 10~19 的情况，省略“一”
            // 仅当这个 section 是最高节，且是 1X（千百为0，十位为1，个位任意）时
            if (isLeadingSection && d0 === 0 && d1 === 0 && d2 === 1) {
                // 处理 10~19
                sectionStr = CN_UNIT[1]; // “十”
                if (d3 !== 0) {
                    sectionStr += CN_NUM[d3];
                }
            } else {
                // 正常处理每一位
                for (let j = 0; j < 4; j++) {
                    const digit = digits[j];
                    const unit = CN_UNIT[3 - j]; // 千:3, 百:2, 十:1, 个:0

                    if (digit === 0) {
                        if (!zeroFlag && sectionStr !== '') {
                            // 需要补“零”，但只补一次
                            // 但先标记，后面统一处理
                            zeroFlag = true;
                        }
                    } else {
                        if (zeroFlag && sectionStr !== '') {
                            sectionStr += CN_NUM[0];
                            zeroFlag = false;
                        }
                        sectionStr += CN_NUM[digit] + unit;
                    }
                }
            }

            // 去掉末尾的“零”
            if (sectionStr.endsWith('零')) {
                sectionStr = sectionStr.slice(0, -1);
            }

            if (sectionStr !== '') {
                result += sectionStr + CN_SECTION[sections.length - i - 1];
                zeroFlag = false;
            }
        }

        if (!result) {
            result = CN_NUM[0];
        }

        // 处理小数
        if (decPart && decPart !== '00') {
            result += '点';
            for (let i = 0; i < decPart.length; i++) {
                result += CN_NUM[parseInt(decPart[i])];
            }
        }

        return result;
    },


      handleView(value, width = 0, height = 0){
        this.isImg = true
        this.isImgs = value
        this.imgWidth = width
        this.imgHeight = height
      },

      closeisImg(){
        this.isImg = false
        this.isImgs = ''
        this.imgWidth = 0
        this.imgHeight = 0
      },


      handleClear(event) {
        console.log('Selected value:', event);
        this.remarks = ''
        this.detailedAddress = ''
        this.newaddress = ''
      },


      // 模拟从后端获取搜索结果
      async querySearchAsync(queryString, cb) {
        if (!queryString) {
          cb([]);
          return;
        }

        // 模拟调用后端接口获取数据
        const results = await this.fetchAddressesFromBackend(queryString);

        // 调用回调函数，传递搜索结果
        cb(results);
      },

      // 模拟后端接口请求
      fetchAddressesFromBackend(query) {
          return new Promise((resolve, reject) => {
            let dateObj = {
              regionName: this.regionName === 1 ? '北京' : this.regionName === 2 ? '深圳' : this.regionName === 3 ? '上海' : this.regionName === 4 ? '广州' : '',
              keyword: query
            }
            axios.post(`${apiBaseUrl}/student/getSiteInfoList`, dateObj,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
              if (res.data.code === 200) {
                console.log(res.data.data, '获取地址列表')
                resolve(res.data.data.map(item => ({
                      value: item.addressTitleName,
                      city: item.districtName,
                      district: item.addressFollow,
                      address: item.addressFollow,
                      latitude: item.latitude,
                      precisionLng: item.precisionLng,
                })));
              } else {
                resolve([]);
                this.$message.error(err);
              }
            }).catch(err => {
              this.$message.error(err);
              reject(new Error('JSONP请求失败'));
            })
        })

   
        
        // return new Promise((resolve, reject) => {
        //     const regionName = this.regionName === 1 ? '北京' : this.regionName === 2 ? '深圳' : this.regionName === 3 ? '上海' : this.regionName === 4 ? '广州' : '';
        //     const apiKey = 'N6HBZ-FHHKL-C5BP2-EBJW7-BC6VZ-NQF3D';
        //     const callbackName = `jsonpCallback_${Date.now()}`;
        //     const script = document.createElement('script');
        //     script.src = `https://apis.map.qq.com/ws/place/v1/suggestion?keyword=${encodeURIComponent(query)}&region=${regionName}&key=${apiKey}&output=jsonp&callback=${callbackName}`;

        //     window[callbackName] = (data) => {
        //         document.body.removeChild(script);
        //         delete window[callbackName];
        //         if (data.status === 0) {
        //             resolve(data.data.map(item => ({
        //                 value: item.title,
        //                 city: item.city,
        //                 district: item.district,
        //                 address: item.address,
        //                 location: item.location,

        //             })));
        //         } else {
        //             console.error('腾讯地图API错误:', data.message);
        //             resolve([]);
        //         }
        //     };

        //     script.onerror = () => {
        //         document.body.removeChild(script);
        //         delete window[callbackName];
        //         reject(new Error('JSONP请求失败'));
        //     };

        //     document.body.appendChild(script);
        // });
      },

      // 当用户选择一个建议时触发
      handleSelect(item) {
        console.log('用户选择了:', item);
        this.infoObj = item
        this.newaddress = item.value; // 确保选中的值绑定到表单中
      },

      handleautocompleteClear(event) {
        this.infoObj = {};
      },


      changeisWantToContinueTheClass (val) {
          console.log(val, '(changeisWantToContinueTheClass)')
      },

      changeisThereACharge (val) {
          console.log(val, '(changeisThereACharge)')
      },

      changeisThereACharge1 (val) {
          console.log(val, '(changeisThereACharge1)')
      },

      changeisThereARefund (val) {
          console.log(val, '(changeisThereARefund)')
          if(val === 2){
            this.isCustomsDeclarationchengRemarks = ''
          }
      },

      changeisYouWantToRenew (val) {
          console.log(val, '(changeisYouWantToRenew)')
      },

      closeisOrderStatus(val) {
        this.isOrderStatusTextarea = ''
        this.isOrderStatus = false
      },

      changeCustomerFunding (val) {

      },

      changeOrderStatus (val) {
          if(val === 2){
             this.isOrderStatus = true
          }else{
            this.isOrderStatus = false
          }
      },


      addInput1 () {
        this.renewalCollectionList.push({
          AcademicExpenses:'',
          AcademicClasses:'',
          FamilyEducationExpenses:'',
          FamilyEducationClass:'',
          AccompanyingReadingFee:'',
          AccompanyingReading:'',
          RemoteRoadRepair:'',
          PaymentTime:'',
          Paymentchannel:'',
          classGiveHour:'', 
          familyGiveHour:'',
          readingGiveHour:'',
          DiagnosticClass : '',
          DiagnosticClassFee : '',
          DiagnosticClassFeeGift : '',
          studentMoney:'',
          studentHour:'',
          studentGiveHour:'',
          patriarchMoney:'',
          patriarchHour:'',
          patriarchGiveHour:'',
          diagnoseMoney:'',
          diagnoseHour:'',
          diagnoseGiveHour:'',
          renewCollectionPicture:[],
        })
      },

      addInput11 () {
        this.renewalCollectionListWay.push({
            Plan:'',
            diagnoseMoney:'',
            diagnoseHour:'',
            diagnoseGiveHour:'',
            AcademicExpenses:'',
            AcademicClasses:'',
            classGiveHour:'',
            FamilyEducationExpenses:'',
            FamilyEducationClass:'',
            familyGiveHour:'',
            studentMoney:'',
            studentHour:'',
            studentGiveHour:'',
            patriarchMoney:'',
            patriarchHour:'',
            patriarchGiveHour:'',
            AccompanyingReadingFee:'',
            AccompanyingReading:'',
            readingGiveHour:'',
            RemoteRoadRepair:'',
            PaymentTime:'',
            Paymentchannel:'',
            chargeCollectionPicture:[],
        })
      },

      removeItem11 () {
        if (this.renewalCollectionListWay.length > 1) {
            this.renewalCollectionListWay.pop()
        } else {
            this.renewalCollectionListWay.splice(0, this.renewalCollectionListWay.length)
        }
      },

      removeItem1 () {
        if (this.renewalCollectionList.length > 1) {
            this.renewalCollectionList.pop()
        } else {
            this.renewalCollectionList.splice(0, this.renewalCollectionList.length)
        }
      },

      startTimeSelect (val, row) {

        if (val == "start") {
          this.order.OffTimeHour = row
        } else if (val == "end") {
          this.order.offEndTime = row
        } else if (val == "start1") {
          this.order.startTimeHour = row
        } else {
          this.order.onEndTime = row
        }

      },

      endTimeSelect (val) {
        this.order.offEndTime = val
      },

      init (customerId,type) {
          this.customerId = customerId
          this.typessssssss = type
          this.isDetail = type === 2 ? true : false
          this.showEdit = true
          axios.get(`${apiBaseUrl}/customerinformation/getOne/${customerId}`,{headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
              if (res.data.code === 200) {

                  //  this.isClassType = 1
                  //  this.isCustomerStatus = 2
                  this.statusId = res.data.data.list.studentId
                  this.contractScheme = res.data.data.list.contractId
                  this.contractTime = res.data.data.list.periodStartTime


                  if (res.data.data.list.prepareAddress instanceof Array) {
                      this.ListDataLngLat = res.data.data && res.data.data.list.prepareAddress.length > 0 ? res.data.data.list.prepareAddress : []
                  } 

                  this.xxxxx = Number(res.data.data.list.regionName)

                  if (res.data.data.list.prepareAddress){
                      let ListDataLngLatLsit = JSON.parse(res.data.data.list.prepareAddress)
                      ListDataLngLatLsit.map((itmes)=>{
                          this.ListDataLngLat.push({
                            value: itmes.addressTitleName,
                            city: itmes.districtName,
                            district: itmes.addressFollow,
                            addressTitleName: itmes.addressTitleName,
                            addressFollow: itmes.addressFollow,
                            districtName: itmes.districtName,
                            address: itmes.addressFollow,
                            latitude: itmes.latitude,
                            precisionLng: itmes.precisionLng,
                            regionName: Number(res.data.data.list.regionName),
                            detailedAddress: itmes.addressInfo ,
                            remarks: itmes.addressRemark ,
                            newaddress: itmes.addressTitleName
                          })
                      })

                      
                  }else{
                    this.ListDataLngLat = []
                  }



                  this.isProject = res.data.data.list.isProject
                  this.isUpdate = res.data.data.list.isUpdate

                  this.isClassType = res.data.data.list.classType
                  this.isCustomerStatus = res.data.data.list.customerType



                  this.chengRemarks = res.data.data.list.commitRemark
                  this.ApprovalPeople = res.data.data.list.auditId


                  this.allIsUpdate = res.data.data.list.allIsUpdate


                  // =========================================================(定金)=======================================================
                  this.OrderStatus = res.data.data.list.orderStatus
                  this.isOrderStatusShow = res.data.data.list.orderStatus

                  this.paymentAmount = res.data.data.list.customerPaymoney
                  this.paymentAmountTime = res.data.data.list.customerPaytime
                  this.paymentAmountChannel = res.data.data.list.payType
                  this.paymentAmountCourse = res.data.data.list.customerHour
                  this.isOrderStatusTextarea = res.data.data.list.notCustomerRemark


                  this.customerHour = res.data.data.list.customerHour
                  this.customerHourType = res.data.data.list.customerHourType

                  this.newaddress = res.data.data.list.addressTitleName
                  this.detailedAddress = res.data.data.list.addressInfo 
                  this.remarks = res.data.data.list.addressRemark
                  this.infoObj.value = res.data.data.list.addressTitleName
                  this.infoObj.address = res.data.data.list.addressFollow
                  this.infoObj.district = res.data.data.list.districtName
                  this.infoObj.latitude = res.data.data.list.latitude
                  this.infoObj.precisionLng = res.data.data.list.precisionLng


                  
                  if(res.data.data.list.clientNeedRemark){
                    this.textareaJson = JSON.parse(res.data.data.list.clientNeedRemark);
                  }else{
                    this.textareaJson = [{}];
                  }



                 if(res.data.data.list.diagnosisCollectionPicture){
                    this.fileAllLists = JSON.parse(res.data.data.list.diagnosisCollectionPicture);
                  }else{
                    this.fileAllLists = [];
                 }


                 this.customerAccountName11 = res.data.data.list.diagnoseTeacherId
                 this.customerAccountName111 = res.data.data.list.projectTeacherId 


                  // =========================================================(成单)=======================================================
                  // (1) 是否收费
                  this.isThereACharge = res.data.data.list.customerIsallpay === 0 ? '' : res.data.data.list.customerIsallpay
           
                  

                  this.isCustomsDeclaration = res.data.data.list.isClose
                  this.isCustomsDeclarationchengRemarks = res.data.data.list.closeCause

                  this.setWay  = res.data.data.list.collectionType === 1 ? '全款' : res.data.data.list.collectionType === 2 ? '分期' : ''

                  if(res.data.data.list.collectionType === 1){
                    this.Plan = res.data.data.list.projectMoney
                    this.AcademicExpenses = res.data.data.list.customerAllpaymoney
                    this.AcademicClasses = res.data.data.list.classHour
                    this.FamilyEducationExpenses = res.data.data.list.familyMoney
                    this.FamilyEducationClass = res.data.data.list.familyHour
                    this.AccompanyingReadingFee = res.data.data.list.readingPartnerMoney
                    this.AccompanyingReading = res.data.data.list.readingPartnerHour
                    this.RemoteRoadRepair = res.data.data.list.wayMoney
                    this.PaymentTime = res.data.data.list.customerAllpaytime
                    this.Paymentchannel = res.data.data.list.payAlltype
                    this.classGiveHour = res.data.data.list.classGiveHour
                    this.familyGiveHour = res.data.data.list.familyGiveHour
                    this.readingGiveHour = res.data.data.list.readingGiveHour
                    this.doubtContent = res.data.data.list.commitRemark ? JSON.parse(res.data.data.list.commitRemark) : []
                  }

                 

                  this.contractAmount = res.data.data.list.contractCost
                  
                  if(this.setWay === '分期'){
                    let renewalCollectionListWay  = res.data.data.list.stages ? JSON.parse(res.data.data.list.stages) : []
                    this.renewalCollectionListWay = renewalCollectionListWay.map((itme)=>{
                       return {
                              

                              Plan: itme.projectMoney || '',
                              diagnoseMoney: itme.diagnoseMoney || '',
                              AcademicExpenses: itme.customerAllpaymoney  || '',
                              FamilyEducationExpenses: itme.familyMoney || '',
                              patriarchMoney: itme.patriarchMoney || '',
                              studentMoney: itme.studentMoney || '',
                              AccompanyingReadingFee: itme.wayMoney || '',
                              RemoteRoadRepair: itme.readingPartnerMoney || '',

                              PaymentTime:itme.stagesDate || '',
                              Paymentchannel: itme.payType || '',
                              chargeCollectionPicture: itme.stagesPicture ? JSON.parse(itme.stagesPicture) : [],
                           
                              diagnoseHour: itme.diagnoseHour,
                              diagnoseGiveHour: itme.diagnoseGiveHour,
                              studentHour: itme.studentHour,
                              studentGiveHour: itme.studentGiveHour,
                              patriarchHour: itme.patriarchHour,
                              patriarchGiveHour: itme.patriarchGiveHour,

                              AcademicClasses: itme.classHour   ? itme.classHour    : '',
                              FamilyEducationClass: itme.familyHour  ? itme.familyHour  : '',
                              AccompanyingReading: itme.readingPartnerHour  ? itme.readingPartnerHour   : '',
                              classGiveHour: itme.classGiveHour ? itme.classGiveHour  : '',
                              familyGiveHour: itme.familyGiveHour ? itme.familyGiveHour  : '',
                              readingGiveHour: itme.readingGiveHour ? itme.readingGiveHour  : '',

                              sumMoney: itme.sumMoney ? itme.sumMoney  : '',              //收款金额
                              stagesDate: itme.stagesDate ? itme.stagesDate  : '',        //收款时间
                              payType: itme.payType ? itme.payType  : '',                 //收款渠道

                              allIsUpdate: itme.stagesIsUpdate,
                              doubtContent: itme.commitRemark ? JSON.parse(itme.commitRemark) : []
                            } 
                    })

                    this.renewalCollectionListWay.map((itme)=>{
                        if(itme.allIsUpdate === 1){
                          this.allIsUpdate = itme.allIsUpdate
                        }
                    })
                  }

                  if(this.setWay === '全款'){


                      this.allIsUpdate = res.data.data.list.allIsUpdate
                      this.Plan =  res.data.data.list.projectMoney ? res.data.data.list.projectMoney  : ''
                      this.AcademicExpenses =  res.data.data.list.customerAllpaymoney ? res.data.data.list.customerAllpaymoney  : ''
                      this.AcademicClasses =  res.data.data.list.classHour ? res.data.data.list.classHour  : ''
                      this.FamilyEducationClass =  res.data.data.list.familyHour ? res.data.data.list.familyHour  : ''
                      this.FamilyEducationExpenses =  res.data.data.list.familyMoney ? res.data.data.list.familyMoney  : ''
                      this.AccompanyingReadingFee =  res.data.data.list.readingPartnerMoney ? res.data.data.list.readingPartnerMoney  : ''
                      this.AccompanyingReading =  res.data.data.list.readingPartnerHour ? res.data.data.list.readingPartnerHour  : ''

                      this.RemoteRoadRepair =  res.data.data.list.wayMoney ? res.data.data.list.wayMoney  : ''
                      this.PaymentTime =  res.data.data.list.customerAllpaytime ? res.data.data.list.customerAllpaytime  : ''
                      this.Paymentchannel =  res.data.data.list.payAlltype ? res.data.data.list.payAlltype  : ''
                      this.classGiveHour =  res.data.data.list.classGiveHour ? res.data.data.list.classGiveHour  : ''
                      this.familyGiveHour =  res.data.data.list.familyGiveHour ? res.data.data.list.familyGiveHour  : ''
                      this.readingGiveHour =  res.data.data.list.readingGiveHour ? res.data.data.list.readingGiveHour  : ''
                      
                      this.diagnoseMoney =  res.data.data.list.diagnoseMoney
                      this.diagnoseHour =  res.data.data.list.diagnoseHour
                      this.diagnoseGiveHour =  res.data.data.list.diagnoseGiveHour
                      this.studentMoney =  res.data.data.list.studentMoney  
                      this.studentHour =  res.data.data.list.studentHour
                      this.studentGiveHour =  res.data.data.list.studentGiveHour
                      this.patriarchMoney =  res.data.data.list.patriarchMoney
                      this.patriarchHour =  res.data.data.list.patriarchHour
                      this.patriarchGiveHour =  res.data.data.list.patriarchGiveHour
                      this.chargeCollectionPicture =  res.data.data.list.chargeCollectionPicture ? JSON.parse(res.data.data.list.chargeCollectionPicture) : []
                      this.doubtContent = res.data.data.list.commitRemark ? JSON.parse(res.data.data.list.commitRemark) : []

                  }

                  console.log(this.renewalCollectionListWay, '11111111111111111111111111111')


                  // (2) 是否续费
                  this.isYouWantToRenew = res.data.data.list.isRenew
                  

                  let renewalCollectionList = res.data.data.list.renews ? JSON.parse(res.data.data.list.renews) : []
                  let newRenewalCollectionList = []
                  renewalCollectionList.map((itme)=>{
                     let newObj = {

                        Plan: itme.projectMoney,
                        AcademicExpenses : itme.renewMoney,
                        AcademicClasses : itme.classHourRenew,
                        FamilyEducationExpenses : itme.familyMoney,
                        FamilyEducationClass : itme.familyHourRenew,
                        AccompanyingReadingFee : itme.readingPartnerMoney,
                        AccompanyingReading : itme.readingPartnerHour,
                        RemoteRoadRepair: itme.wayMoney,
                        PaymentTime : itme.renewTime,
                        Paymentchannel : itme.renewType,
                        classGiveHour: itme.classGiveHour,
                        familyGiveHour: itme.familyGiveHour,
                        readingGiveHour: itme.readingGiveHour,
                        
                        diagnoseHour: itme.diagnoseHour || '',
                        diagnoseMoney: itme.diagnoseMoney || '',
                        diagnoseGiveHour: itme.diagnoseGiveHour || '',
                        patriarchHour: itme.patriarchHour || '',
                        patriarchGiveHour: itme.patriarchGiveHour || '',
                        patriarchMoney: itme.patriarchMoney || '',
                        studentHour: itme.studentHour || '',
                        studentGiveHour: itme.studentGiveHour || '',
                        studentMoney: itme.studentMoney || '',
                        renewCollectionPicture: itme.renewCollectionPicture ? JSON.parse(itme.renewCollectionPicture) : [],

                        sumMoney: itme.sumMoney,            //收款金额
                        renewTime: itme.renewTime,          //收款时间
                        renewType: itme.renewType,          //收款渠道

                        allIsUpdate: itme.renewIsUpdate,
                        doubtContent: itme.commitRemark ? JSON.parse(itme.commitRemark) : []
                        
                     }  

                     newRenewalCollectionList.push(newObj)
                  })

                  this.renewalCollectionList = newRenewalCollectionList

                  this.renewalCollectionList.map((itme)=>{
                        if(itme.allIsUpdate === 1){
                          this.allIsUpdate = itme.allIsUpdate
                        }
                  })

                  console.log(this.renewalCollectionListWay, '分期')
                  console.log(this.renewalCollectionList, '续费')
                  

                  // (3) 是否退费
                  this.isThereARefund = res.data.data.list.isReturnPremium === 0 ? '' : res.data.data.list.isReturnPremium




                  // =========================================================(退费)=======================================================
                  this.isWantToContinueTheClass = res.data.data.list.isContinueType



                if(this.typeCustomerFunding === '退费' && res.data.data.list.returnPremium){
                      this.isCustomerStatus = res.data.data.list.customerReturnType

                      res.data.data.list.returnPremium = JSON.parse(res.data.data.list.returnPremium)

                      console.log(res.data.data.list.returnPremium, '退费=========》》》》》》》》》')
                  
                      this.AcademicExpenses = res.data.data.list.returnPremium.returnPremiumPrice
                      this.PaymentTime = res.data.data.list.returnPremium.returnPremiumDate
                      this.Paymentchannel = res.data.data.list.returnPremium.returnPremiumPayType
                      this.AcademicClasses = res.data.data.list.returnPremium.returnPremiumHour
                      this.Plan = res.data.data.list.returnPremium.projectMoney
                      this.FamilyEducationExpenses = res.data.data.list.returnPremium.familyMoney
                      this.FamilyEducationClass = res.data.data.list.returnPremium.familyHourRenew
                      this.AccompanyingReadingFee = res.data.data.list.returnPremium.readingPartnerMoney
                      this.AccompanyingReading = res.data.data.list.returnPremium.readingPartnerHour
                      this.classGiveHour = res.data.data.list.returnPremium.classGiveHour
                      this.familyGiveHour = res.data.data.list.returnPremium.familyGiveHour 
                      this.readingGiveHour = res.data.data.list.returnPremium.readingGiveHour
                      this.studentMoney = res.data.data.list.returnPremium.studentMoney
                      this.diagnoseMoney = res.data.data.list.returnPremium.diagnoseMoney
                      this.diagnoseHour = res.data.data.list.returnPremium.diagnoseHour
                      this.diagnoseGiveHour = res.data.data.list.returnPremium.diagnoseGiveHour
                      this.studentHour = res.data.data.list.returnPremium.studentHour
                      this.studentGiveHour  = res.data.data.list.returnPremium.studentGiveHour
                      this.patriarchMoney = res.data.data.list.returnPremium.patriarchMoney
                      this.patriarchHour  = res.data.data.list.returnPremium.patriarchHour
                      this.patriarchGiveHour = res.data.data.list.returnPremium.patriarchGiveHour
                      this.chargeCollectionPicture = res.data.data.list.returnPremium.chargeCollectionPicture ? JSON.parse(res.data.data.list.returnPremium.chargeCollectionPicture) : []

                      this.allIsUpdate = res.data.data.list.returnPremium.returnIsUpdate
                      this.doubtContent = res.data.data.list.returnPremium.commitRemark ? JSON.parse(res.data.data.list.returnPremium.commitRemark) : []

                      // this.AcademicExpenses = res.data.data.list.returnPremium.classMoney
                            
                      if(res.data.data.list.returnPremium.wayMoney){
                         this.RemoteRoadRepair = res.data.data.list.returnPremium.wayMoney
                      }

                     this.isreturnPremium = true

                  }else{
                     if(this.typeCustomerFunding === '退费'){
                        this.isCustomerStatus = res.data.data.list.customerReturnType
                        this.isreturnPremium = false
                        this.AcademicExpenses = ''
                        this.PaymentTime = ''
                        this.Paymentchannel = ''
                        this.AcademicClasses = ''
                        this.Plan = ''
                        this.FamilyEducationExpenses = ''
                        this.FamilyEducationClass = ''
                        this.AccompanyingReadingFee = ''
                        this.AccompanyingReading = ''
                        this.classGiveHour = ''
                        this.familyGiveHour = ''
                        this.readingGiveHour = ''
                        this.studentMoney = ''
                        this.diagnoseMoney = ''
                        this.diagnoseHour = ''
                        this.diagnoseGiveHour = ''
                        this.studentHour = ''
                        this.studentGiveHour  = ''
                        this.patriarchMoney = ''
                        this.patriarchHour  = ''
                        this.patriarchGiveHour = ''
                        this.chargeCollectionPicture =  []
                        this.doubtContent = []
                        this.allIsUpdate = 2
                     }
                  }

                  console.log(this.chargeCollectionPicture , 'this.chargeCollectionPicturechargeCollectionPicturechargeCollectionPicturechargeCollectionPicture')



                 // =================================================================================================


                  this.order.studentId = res.data.data.list.studentId;
                  this.order.isRenew = res.data.data.list.isRenew + ''
                  if (res.data.data.list.renew != null) {
                    this.order.renews = JSON.parse(res.data.data.list.renew)
                  }
                  this.order.state = res.data.data.list.state
                  this.order.classHour = res.data.data.list.classHour ? res.data.data.list.classHour : ""
                  this.order.familyHour = res.data.data.list.familyHour ? res.data.data.list.familyHour : ""
                  this.order.classType = res.data.data.list.classType
                  this.order.remarks = res.data.data.list.remarks;
                  this.order.parentPhoneNumber = res.data.data.list.parentPhoneNumber;
                  this.order.customerInformationId = res.data.data.list.customerId;
                  this.order.studentName = res.data.data.list.customerStudent;
                  this.order.payType = res.data.data.list.payType;
                  this.order.sex = res.data.data.list.sex;
                  this.order.grade = res.data.data.list.gradeIdArr2;
                  this.order.courseCategoryIds = res.data.data.list.categoryIdArr2;
                  this.order.address = res.data.data.list.address;
                  this.order.regionName = Number(res.data.data.list.regionName);
                  this.order.teacherIdOnline = res.data.data.list.teacherIdOnline;
                  this.order.teacherIdOffline = res.data.data.list.teacherIdOffline;

                  // xiaoshou 销售
                  this.customerAccountName = res.data.data.list.customerAccount;
                  this.orderSaleId = res.data.data.list.customerAccount;

                  // 线上诊断
                  if (res.data.data.list.teacherIdOnline == null && res.data.data.list.teacherIdOnlineArr == null) {
                    this.order.teacherIdOnlineArr = []
                  } else {
                    if (res.data.data.list.teacherIdOnlineArr == []) {
                      this.order.teacherIdOnlineArr = []
                    } else {
                      if (res.data.data.list.teacherIdOnlineArr) {
                        this.order.teacherIdOnlineArr = JSON.parse(res.data.data.list.teacherIdOnlineArr)
                      } else {
                        this.order.teacherIdOnlineArr = [res.data.data.list.teacherIdOnline]
                      }
                    }
                  }
                  // 线下诊断
                  if (res.data.data.list.teacherIdOffline == null && res.data.data.list.teacherIdOfflineArr == null) {
                      this.order.teacherIdOfflineArr = []
                  } else {
                    if (res.data.data.list.teacherIdOfflineArr == []) {
                        this.order.teacherIdOfflineArr = []
                    } else {
                      if (res.data.data.list.teacherIdOfflineArr) {
                          this.order.teacherIdOfflineArr = JSON.parse(res.data.data.list.teacherIdOfflineArr)
                      } else {
                          this.order.teacherIdOfflineArr = [res.data.data.list.teacherIdOffline]
                      }
                    }
                  }

                  this.order.teacherIdOnline = null;
                  this.order.teacherIdOffline = null;
                  this.order.startTime = JSON.parse(res.data.data.list.onlineTime);
                  this.order.orderStatus = res.data.data.list.orderStatus
                  this.order.isDiagnosisAllPay = res.data.data.list.customerIspay + "";
                  this.order.diagnosisTime = res.data.data.list.customerPaytime;

                  this.order.diagnosisAllPayMoney =
                    res.data.data.list.customerPaymoney;
                  if (res.data.data.list.onlineTime !== null) {
                    this.order.onTime = JSON.parse(res.data.data.list.onlineTime)[0];
                    this.order.startTimeHour = JSON.parse(
                      res.data.data.list.onlineTime
                    )[1];
                    this.order.onEndTime = JSON.parse(
                      res.data.data.list.onlineTime
                    )[2];
                  }
                  if (res.data.data.list.offlineTime !== null) {
                    this.order.offTime = JSON.parse(
                      res.data.data.list.offlineTime
                    )[0];
                    this.order.OffTimeHour = JSON.parse(
                      res.data.data.list.offlineTime
                    )[1];
                    this.order.offEndTime = JSON.parse(
                      res.data.data.list.offlineTime
                    )[2];
                  }

                  // 销售
                  // this.order.saleId = res.data.data.list.saleId;

                  this.order.onlineStatus = res.data.data.list.onlineStatus;
                  this.order.offlineStatus = res.data.data.list.offlineStatus;
                  this.order.payAlltype = res.data.data.list.payAlltype;
                  this.order.isAllPay = res.data.data.list.customerIsallpay
                  this.order.allPayMoney = res.data.data.list.customerAllpaymoney;
                  this.order.payTime = res.data.data.list.customerAllpaytime;

                   this.order.educationType = res.data.data.list.educationType + '';

                  if (this.order.onlineStatus == "1") {
                    this.checked = true;
                  } else {
                    this.checked = false;
                  }
                  if (this.order.offlineStatus == "1") {
                    this.checked1 = true;
                  } else {
                    this.checked1 = false;
                  }
                  if (res.data.data.list.stages !== null) {
                    this.order.stages = JSON.parse(res.data.data.list.stages);
                  }
              } else {
                this.$message({ message: res.data.message,  type: "error"  });
              }
            })

        },

        closeEditDialog () {

          this.$emit("newModesCustomerFundingDetailEvent")


          if (this.customerId === 0) {
            this.showEdit = false;
          } else {
            this.showEdit = false;
            this.$emit("resetSuccesType", this.customer);
          }
          this.order.isDiagnosisAllPay = "";
          this.order.diagnosisAllPayMoney = "";
          this.order.diagnosisTime = "";
          this.order.diagnosisPayType = "";
          this.order.isAllPay = "";
          this.order.allPayMoney = "";
          this.order.payTime = "";
          this.order.payType = "";
          this.order.state = "";
          this.order.classHour = ""
          this.order.familyHour = ""
          this.order.renews = [{ renewMoney: "", renewTime: "",  renewType: "" , classHourRenew: "", familyHourRenew: "" }]
          this.order.stages = [{ stagesMoney: "",  stagesDate: "",  payType: "", agingClassHour: "", agingFamilyHour: "" }]
          this.$refs.order.resetFields();
          this.order.startTimeHour = ""
          this.order.onEndTime = ""
          this.order.OffTimeHour = ""
          this.order.offEndTime = ""
        },

        phoneChange() {
      this.order.parentPhoneNumber = this.order.parentPhoneNumber.replace(/[^\d]/g, "");
      if (this.order.parentPhoneNumber.length > 11) {
        this.order.parentPhoneNumber = this.order.parentPhoneNumber.substr(0, 11);
      }
      let reg = /^1[3456789]\d{9}$/;
      if (this.order.parentPhoneNumber.length >= 11 && !reg.test(this.order.parentPhoneNumber)) {
         this.$notify({
          title: '警告',
          message: '请输入正确的手机号码格式',
          type: 'warning'
        });
      }
    },
    qq () {
      console.log(this.order.isRenew);
    },


    handleinput(e){
      console.log(e)
    },
    clickitem (val) {

      if(this.order.isAllPay === val ){
         this.order.isAllPay = ''
      }else{
         this.order.isAllPay = val
      }

      if(val === 1){
          this.order.allPayMoney = ""
          this.order.payTime = ""
          this.order.payAlltype = ""
          this.order.classHour = ""
          this.order.familyHour = ""
      }
      if(val === 2){
        this.order.stages = [
          {
            stagesMoney: "", // 分期金额
            stagesDate: "", // 分期时间
            payType: "", // 收款渠道
            agingClassHour: "",
            agingFamilyHour: ""
          }
        ]
      }
    },
    clean (val) {
      if (val == "start") {
        this.diagnosisOff.startTimeHour = ''
      } else {
        this.diagnosisOff.endTimeHour = ''
      }
    },
    clearDiagnosis () {
      if (
        this.order.isDiagnosisAllPay == "2" ||
        this.order.isDiagnosisAllPay == "3"
      ) {
        this.order.diagnosisAllPayMoney = "";
        this.order.diagnosisTime = "";
        this.order.diagnosisPayType = "";
      }
    },
    //点击显示钟表
    // dianji() {
    //   this.isshow = !this.isshow;
    // },
    // dianji1() {
    //   this.isshow1 = !this.isshow1;
    // },
    //绑定课程id
    handleChange (val) {
      if (val === this.Lastselected) {
        // 取消选择
        this.isDiagnosisAllPay = '';
      }
      this.Lastselected = this.isDiagnosisAllPay;
    },
    // bingCategory() {
    //   if (this.order.diagnosisAllPayMoney == 2000) {
    //     this.order.courseCategoryId = [25, 26];
    //   }
    // },


    isFull () {
      this.order.stages = [
        {
          stagesMoney: "", // 分期金额
          stagesDate: "", // 分期时间
          payType: "", // 收款渠道
          agingClassHour: "",
          agingFamilyHour: ""
        }
      ];
    },
    isNo () {
      this.order.allPayMoney = "";
      this.order.payTime = "";
      this.order.payAlltype = "";
    },
    //添加输入框
    addInput () {
      this.order.stages.push({
        stagesMoney: "",
        stagesDate: "",
        payType: "", // 收款渠道
        agingClassHour: "",
        agingFamilyHour: ""
      });
    },
    //减少输入框
    removeItem () {
      if (this.order.stages.length > 1) {
        this.order.stages.pop();
      } else {
        this.order.stages.splice(0, this.order.stages.length);
      }
    },

    orderShow (customer) {
      this.showEdit = true;
      this.customer = customer;
      this.order.studentName = customer.customerStudent;
      this.order.type = customer.type;
      this.order.customerInformationId = customer.customerId;
      this.customerId = customer.customerId;
    },

    getGrade () {
      axios
        .get(`${apiBaseUrl}/grade/getGrade`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.data.length > 0) {
            this.order.gradeList = res.data.data;
          } else {
            this.$message({
              message: "获取年级列表失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    getTeachers () {
      axios
        .get(`${apiBaseUrl}/schedule/teacherDiagnosisList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.teachers = res.data.data;
        })
        .catch(error => {
          this.$message({
            message: "获取老师列表失败",
            type: "error"
          });
        });
    },
    //获取课程类别
    getCategoryList () {
      axios
        .get(`${apiBaseUrl}/category/list`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.categoryList = res.data.data;
        })
        .catch(error => {
          this.$message({
            message: "获取课程列表失败",
            type: "error"
          });
        });
    },

     getNowTime() {
        var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      var hour = date.getHours();
      var minute = date.getMinutes();
      var second = date.getSeconds();
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day;
      hour = hour < 10 ? "0" + hour : hour;
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
    },


    saveEditForm1(){
      if(this.order.offTime && (this.order.teacherIdOfflineArr && this.order.teacherIdOfflineArr.length > 0) ){
          let data = { 
            courseDate: this.order.offTime ? this.order.offTime : '', 
            teacher_id: this.order.teacherIdOfflineArr && this.order.teacherIdOfflineArr.length > 0 ? this.order.teacherIdOfflineArr.join(',') : '', 
            relativeTime: 4,
            num:'',
            checkList:"",
          }
          axios.post(`${apiBaseUrl}/attendanceWXTeacher/queryTeacherLeave`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
            if (res.data.code === 200) {
                if(res.data.data && res.data.data.length > 0){
                  let len = res.data.data[0]
                  // this.$message.warning(len)
                  if(len){
                    this.$confirm( len + '确认继续提交？', '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                    }).then(() => {
                      this.saveEditForm()
                    })
                  }else{
                    this.saveEditForm()
                  }
                }else{
                    this.saveEditForm()
                }
            } else {
              this.saveEditForm()
              this.$message.error('请联系管理员~');
            }
          }).catch(err => {
            this.saveEditForm()
            this.$message.error(err,'请联系管理员~');
          })  
      }else{
        this.saveEditForm()
      }
    },

    
    saveEditForm () {
      
     // 销售
     this.optionsList.map((item)=>{
       if(item.label === this.customerAccountName){
         this.orderSaleId = item.id
         this.order.saleId = item.id
         return
       }
     })


      
      if(this.typeCustomerFunding != '定金' && this.typeCustomerFunding != '退费'){
        if(this.isClassType === 1 ){
            if(this.contractScheme && this.contractTime){
                    if (this.checked == true) {
                        this.order.onlineStatus = "1";
                    } else {
                        this.order.onlineStatus = "2";
                    }

                    if (this.checked1 == true) {
                        this.order.offlineStatus = "1";
                    } else {
                        this.order.offlineStatus = "2";
                    }

                // this.$refs["order"].validate(valid => {
                //   if (valid) {
                    this.order.onlineTime = [ this.order.onTime,  this.order.startTimeHour,  this.order.onEndTime  ];

                    if (this.order.onlineTime.length == 0) {
                        this.order.onlineTime = "";
                    }

                    this.order.offlineTime = [ this.order.offTime,  this.order.OffTimeHour,  this.order.offEndTime  ];

                    if (this.order.offlineTime.length == 0) {
                        this.order.offlineTime = "";
                    }

                    // if (this.order.isRenew == 2) {
                    //     this.order.renews = null
                    // }



                    this.order.classHour = this.order.classHour ? Number(this.order.classHour) : 0
                    this.order.familyHour = this.order.familyHour ? Number(this.order.familyHour) : 0


                    if(this.order.stages && this.order.stages.length > 1){
                      this.order.stages.forEach((itme)=>{
                        itme.agingClassHour = itme.agingClassHour ? Number(itme.agingClassHour) : 0
                        itme.agingFamilyHour = itme.agingFamilyHour ? Number(itme.agingFamilyHour) : 0
                      })
                    }else{
                      //  this.order.stages = []
                    }

                    if(this.order.renews && this.order.renews.length > 1){
                      this.order.renews.forEach((itme)=>{
                        itme.familyHourRenew = itme.familyHourRenew ? Number(itme.familyHourRenew) : 0
                        itme.classHourRenew = itme.classHourRenew ? Number(itme.classHourRenew) : 0
                      })
                    }else{
                      //  this.order.renews = []
                    }

                    this.order.customerIsallpay = this.order.isAllPay

                    // this.order.renews = JSON.stringify(this.order.renews)
                    // this.order.stages = JSON.stringify(this.order.stages)

                    this.order.auditId = this.ApprovalPeople
                    this.order.commitRemark = this.chengRemarks

                    // 销售
               


                    let newObj = {   }

                    let list = [];
                    if(this.newTextareaJson){
                    list = [{ remark: this.newTextareaJson, remarkDate: this.getNowTime() }];
                    this.textareaJson.push(...list);
                    }


                    if(this.typeCustomerFunding === '定金'){

                        if(this.paymentAmount){
                          if(this.paymentAmountTime && this.paymentAmountChannel && this.paymentAmountCourse && this.fileAllLists.length > 0 ){
                              
                          }else{
                            this.$message({ message: "请填写必填项",  type: "warning" });
                            return
                          }
                      
                        }


                        newObj = {

                          classType: this.isClassType ? this.isClassType : '',
                          diagnosisAllPayMoney: this.paymentAmount ? this.paymentAmount : '',
                          diagnosisTime: this.paymentAmountTime ? this.paymentAmountTime : '',
                          payType: this.paymentAmountChannel ? this.paymentAmountChannel : '',
                          customerHour: this.paymentAmountCourse ? this.paymentAmountCourse : '',
                          orderStatus: this.OrderStatus ,
                          notCustomerRemark: this.isOrderStatusTextarea ? this.isOrderStatusTextarea : '',


                          regionName: this.regionName ? this.regionName : '',
                          addressTitleName: this.infoObj.value ? this.infoObj.value : '',
                          addressFollow: this.infoObj.address ? this.infoObj.address : '',
                          addressInfo: this.detailedAddress ? this.detailedAddress : '',
                          addressRemark: this.remarks ? this.remarks : '',
                          districtName: this.infoObj.city ? this.infoObj.city : '',
                          latitude: this.infoObj.latitude ? this.infoObj.latitude : '',
                          precisionLng: this.infoObj.precisionLng ? this.infoObj.precisionLng : '',

                          clientNeedRemark:JSON.stringify(this.textareaJson),

                          diagnosisCollectionPicture: this.fileAllLists.length > 0 ? JSON.stringify(this.fileAllLists) : JSON.stringify([]),
                          

                          projectTeacherId: this.customerAccountName111,
                          diagnoseTeacherId: this.customerAccountName11,

                        }
                    }


                    if(this.typeCustomerFunding === '成单'){

                        let newStringLsit = this.renewalCollectionList.map((itme)=>{
                          let itmes = {

                              projectMoney: itme.Plan,
                              renewMoney: itme.AcademicExpenses || '',
                              classHourRenew: itme.AcademicClasses || '',
                              familyMoney: itme.FamilyEducationExpenses || '',
                              familyHourRenew: itme.FamilyEducationClass || '',
                              readingPartnerMoney: itme.AccompanyingReadingFee || '',
                              readingPartnerHour: itme.AccompanyingReading || '',
                              wayMoney: itme.RemoteRoadRepair || '',
                              renewTime: itme.PaymentTime || '',
                              renewType: itme.Paymentchannel || '',
                              classGiveHour: itme.classGiveHour || '',
                              familyGiveHour: itme.familyGiveHour || '',
                              readingGiveHour: itme.readingGiveHour || '',

                              diagnoseHour: itme.diagnoseHour || '',
                              diagnoseMoney: itme.diagnoseMoney || '',
                              diagnoseGiveHour: itme.diagnoseGiveHour || '',
                              patriarchHour: itme.patriarchHour || '',
                              patriarchGiveHour: itme.patriarchGiveHour || '',
                              patriarchMoney: itme.patriarchMoney || '',
                              studentHour: itme.studentHour || '',
                              studentGiveHour: itme.studentGiveHour || '',
                              studentMoney: itme.studentMoney || '',
                              renewCollectionPicture: itme.renewCollectionPicture && itme.renewCollectionPicture.length > 0 ? JSON.stringify(itme.renewCollectionPicture) : JSON.stringify([]),

                              projectTeacherId: this.customerAccountName111,
                              diagnoseTeacherId: this.customerAccountName11,

                          }
                          return itmes
                        })



                        if(this.setWay === '全款' ){

                            
                              newObj = {
                                classType: this.isClassType ? this.isClassType : '',

                                projectMoney: this.Plan ? this.Plan  : '',
                                allPayMoney: this.AcademicExpenses ? this.AcademicExpenses  : '',
                                classHour: this.AcademicClasses ? this.AcademicClasses  : '',
                                familyHour: this.FamilyEducationClass ? this.FamilyEducationClass  : '',
                                familyMoney: this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : '',
                                readingPartnerMoney: this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : '',
                                readingPartnerHour: this.AccompanyingReading ? this.AccompanyingReading  : '',
                                
                                wayMoney: this.RemoteRoadRepair ? this.RemoteRoadRepair  : '',
                                payTime: this.PaymentTime ? this.PaymentTime  : '',
                                payAlltype: this.Paymentchannel ? this.Paymentchannel  : '',
                                
                                classGiveHour: this.classGiveHour ? this.classGiveHour  : '',
                                familyGiveHour: this.familyGiveHour ? this.familyGiveHour  : '',
                                readingGiveHour: this.readingGiveHour ? this.readingGiveHour  : '',
                                
                                stages: JSON.stringify([]),
                                renews: newStringLsit ? JSON.stringify(newStringLsit) : '[]',

                                isAllPay: this.isThereACharge ? this.isThereACharge : '',
                                isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                                isReturnPremium: this.isThereARefund ? this.isThereARefund : '',
                                auditId: this.ApprovalPeople ? this.ApprovalPeople : '',
                                commitRemark: this.chengRemarks ? this.chengRemarks : '',

                                isClose: this.isCustomsDeclaration,
                                closeCause: this.isCustomsDeclarationchengRemarks,




                                projectMoney: this.Plan,
                                diagnoseMoney: this.diagnoseMoney,
                                diagnoseHour: this.diagnoseHour,
                                diagnoseGiveHour: this.diagnoseGiveHour,
                                studentMoney: this.studentMoney,
                                studentHour: this.studentHour,
                                studentGiveHour: this.studentGiveHour,
                                patriarchMoney: this.patriarchMoney,
                                patriarchHour: this.patriarchHour,
                                patriarchGiveHour: this.patriarchGiveHour,
                                chargeCollectionPicture: this.chargeCollectionPicture.length > 0 ? JSON.stringify(this.chargeCollectionPicture) : JSON.stringify([]),


                                collectionType: this.setWay === '全款' ? 1 : this.setWay === '分期' ? 2 : '',
                                isProject: this.isProject,
                                contractCost: this.contractAmount,

                                projectTeacherId: this.customerAccountName111,
                                diagnoseTeacherId: this.customerAccountName11,

                              }
                            
                        }


                        if(this.setWay === '分期' ){

                            let renewalCollectionListWay =  this.renewalCollectionListWay.map((itme,index)=>{
                                  return {
                                      
                                        projectMoney: itme.Plan || '',
                                        diagnoseMoney: itme.diagnoseMoney || '',
                                        customerAllpaymoney: itme.AcademicExpenses || '',
                                        familyMoney: itme.FamilyEducationExpenses || '',
                                        patriarchMoney: itme.patriarchMoney || '',
                                        studentMoney: itme.studentMoney || '',
                                        wayMoney: itme.AccompanyingReadingFee || '',
                                        readingPartnerMoney: itme.RemoteRoadRepair || '',

                                        stagesDate:itme.PaymentTime || '',
                                        payType: itme.Paymentchannel || '',
                                        stagesPicture: itme.chargeCollectionPicture ? JSON.stringify(itme.chargeCollectionPicture) : JSON.stringify([]),

                                        diagnoseHour: itme.diagnoseHour,
                                        diagnoseGiveHour: itme.diagnoseGiveHour,
                                        studentHour: itme.studentHour,
                                        studentGiveHour: itme.studentGiveHour,
                                        patriarchHour: itme.patriarchHour,
                                        patriarchGiveHour: itme.patriarchGiveHour,

                                        classHour: itme.AcademicClasses ? itme.AcademicClasses  : '',
                                        familyHour: itme.FamilyEducationClass ? itme.FamilyEducationClass  : '',
                                        readingPartnerHour: itme.AccompanyingReading ? itme.AccompanyingReading  : '',
                                        payTime: itme.PaymentTime ? itme.PaymentTime  : '',
                                        payAlltype: itme.Paymentchannel ? itme.Paymentchannel  : '',
                                        classGiveHour: itme.classGiveHour ? itme.classGiveHour  : '',
                                        familyGiveHour: itme.familyGiveHour ? itme.familyGiveHour  : '',
                                        readingGiveHour: itme.readingGiveHour ? itme.readingGiveHour  : '',
                                      } 
                            })



                            newObj = {
                            
                              classType: this.isClassType ? this.isClassType : '',

                              renews: newStringLsit ? JSON.stringify(newStringLsit) : '[]',
                              isAllPay: this.isThereACharge ? this.isThereACharge : '',
                              isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                              isReturnPremium: this.isThereARefund ? this.isThereARefund : '',
                              auditId: this.ApprovalPeople ? this.ApprovalPeople : '',
                              commitRemark: this.chengRemarks ? this.chengRemarks : '',
                              isClose: this.isCustomsDeclaration,
                              closeCause: this.isCustomsDeclarationchengRemarks,


                              collectionType: this.setWay === '全款' ? 1 : this.setWay === '分期' ? 2 : '',
                              isProject: this.isProject,
                              contractCost: this.contractAmount,

                              stages: renewalCollectionListWay ? JSON.stringify(renewalCollectionListWay) : '[]',

                              projectTeacherId: this.customerAccountName111,
                              diagnoseTeacherId: this.customerAccountName11,

                            }

                        }
                        
                    }


                    if(this.typeCustomerFunding === '退费'){
                        newObj = {
                          classType: this.isClassType || '',
                          customerReturnType: this.isWantToContinueTheClass || '',
                          projectTeacherId: this.customerAccountName111,
                          diagnoseTeacherId: this.customerAccountName11,

                          returnPremium: JSON.stringify({
                              projectMoney: this.Plan || '',
                              returnPremiumPrice: this.AcademicExpenses || '',
                              returnPremiumHour: this.AcademicClasses || '',
                              familyMoney: this.FamilyEducationExpenses || '',
                              familyHourRenew: this.FamilyEducationClass || '',
                              readingPartnerMoney: this.AccompanyingReadingFee || '',
                              readingPartnerHour: this.AccompanyingReading || '',
                              wayMoney: this.RemoteRoadRepair || '',
                              returnPremiumDate: this.PaymentTime || '',
                              returnPremiumPayType: this.Paymentchannel || '',

                              projectMoney: this.Plan ? this.Plan  : '',
                              allPayMoney: this.AcademicExpenses ? this.AcademicExpenses  : '',
                              classHour: this.AcademicClasses ? this.AcademicClasses  : '',
                              familyHour: this.FamilyEducationClass ? this.FamilyEducationClass  : '',
                              familyMoney: this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : '',
                              readingPartnerMoney: this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : '',
                              readingPartnerHour: this.AccompanyingReading ? this.AccompanyingReading  : '',
                                    
                              wayMoney: this.RemoteRoadRepair ? this.RemoteRoadRepair  : '',
                              payTime: this.PaymentTime ? this.PaymentTime  : '',
                              payAlltype: this.Paymentchannel ? this.Paymentchannel  : '',
                              
                              classGiveHour: this.classGiveHour ? this.classGiveHour  : '',
                              familyGiveHour: this.familyGiveHour ? this.familyGiveHour  : '',
                              readingGiveHour: this.readingGiveHour ? this.readingGiveHour  : '',
                              projectMoney: this.Plan,
                              diagnoseMoney: this.diagnoseMoney,
                              diagnoseHour: this.diagnoseHour,
                              diagnoseGiveHour: this.diagnoseGiveHour,
                              studentMoney: this.studentMoney,
                              studentHour: this.studentHour,
                              studentGiveHour: this.studentGiveHour,
                              patriarchMoney: this.patriarchMoney,
                              patriarchHour: this.patriarchHour,
                              patriarchGiveHour: this.patriarchGiveHour,
                              chargeCollectionPicture: this.chargeCollectionPicture.length > 0 ? JSON.stringify(this.chargeCollectionPicture) : JSON.stringify([]),



                          }),

                          isContinueType: this.isWantToContinueTheClass || '',
                          auditId: this.ApprovalPeople || '',
                          commitRemark: this.chengRemarks || '',




                          classType: this.isClassType ? this.isClassType : '',
                          isAllPay: this.isThereACharge ? this.isThereACharge : '',
                          isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                          isReturnPremium: this.isThereARefund ? this.isThereARefund : '',
                          auditId: this.ApprovalPeople ? this.ApprovalPeople : '',
                          commitRemark: this.chengRemarks ? this.chengRemarks : '',

                          isClose: this.isCustomsDeclaration,
                          closeCause: this.isCustomsDeclarationchengRemarks,



                          


                          collectionType: this.setWay === '全款' ? 1 : this.setWay === '分期' ? 2 : '',
                          isProject: this.isProject,
                          contractCost: this.contractAmount,

                        }
                    }


                    let keys = Object.keys(newObj)
                    keys.forEach((key)=>{
                      if (this.order.hasOwnProperty(key)) {
                          delete this.order[key]
                      }
                    })
                    let dateObj = Object.assign(newObj, this.order)
                    let isUrView = this.isUrView


                    dateObj.customerId = this.customerId
                    dateObj.customerInformationId = this.order.customerInformationId

                    dateObj.saleId   = this.orderSaleId  

                    if(this.isClassType){
                      axios.post(`${apiBaseUrl}${isUrView}`, dateObj,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {

                            if (res.data.code === 200) {

                              this.$message({  message: "编辑成功",  type: "success" });


                              this.$emit("newModesCustomerFundingDetailEvent");

                              this.$emit("refreshOrder");
                              this.showEdit = false;

                              this.infoObj = {}
                              this.remarks = ''
                              this.detailedAddress = ''
                              this.newaddress = ''  
                              this.regionName = ''

                              this.customerAccountName11 = ''
                              this.customerAccountName111 = ''
                                  

                              this.ApprovalPeople = "";
                              this.chengRemarks = "";
                              this.order.auditId = "";
                              this.order.commitRemark = "";

                              this.order.isDiagnosisAllPay = "";
                              this.order.diagnosisAllPayMoney = "";
                              this.order.diagnosisTime = "";
                              this.order.diagnosisPayType = "";
                              this.order.isAllPay = "";
                              this.order.allPayMoney = "";
                              this.order.payTime = "";
                              this.order.payType = "";

                              this.order.startTimeHour = ""
                              this.order.onEndTime = ""
                              this.order.OffTimeHour = ""
                              this.order.offEndTime = ""

                              this.order.classHour = ""
                              this.order.familyHour = ""

                              this.order.renews = [{  renewMoney: "",  renewTime: "",   renewType: ""  , classHourRenew: "", familyHourRenew: "" }]

                              this.order.stages = [ { stagesMoney: "",  stagesDate: "",   payType: "" , agingClassHour: "", agingFamilyHour: "" }]

                              this.$refs.order.resetFields();
                              // this.order.startTime.splice(0, this.order.startTime.length);
                            } else {
                                this.$message({ message: res.data.msg ? res.data.msg : res.data.message, type: "error"  });
                                this.order.classHour = this.order.classHour ? Number(this.order.classHour) : ""
                                this.order.familyHour = this.order.familyHour ? Number(this.order.familyHour) : ""

                                if(this.order.stages.length > 1){
                                  this.order.stages.forEach((itme)=>{
                                    itme.agingClassHour = itme.agingClassHour ? Number(itme.agingClassHour) : ""
                                    itme.agingFamilyHour = itme.agingFamilyHour ? Number(itme.agingFamilyHour) : ""
                                  })
                                }

                                if(this.order.renews.length > 1){
                                  this.order.renews.forEach((itme)=>{
                                    itme.familyHourRenew = itme.familyHourRenew ? Number(itme.familyHourRenew) : ""
                                    itme.classHourRenew = itme.classHourRenew ? Number(itme.classHourRenew) : ""
                                  })
                                }
                            }
                          });
                    //   }
                    // });
                        this.$emit("refresh");
                    }else{
                      this.$message({ message: "请选择学生类型", type: "warning"  });
                    }

            }else{
              this.$message({
                message: "请选择签约包！",
                type: "warning"
              });
            }
        }
      }else{
             if (this.checked == true) {
                    this.order.onlineStatus = "1";
                } else {
                    this.order.onlineStatus = "2";
                }

                if (this.checked1 == true) {
                    this.order.offlineStatus = "1";
                } else {
                    this.order.offlineStatus = "2";
                }

            // this.$refs["order"].validate(valid => {
            //   if (valid) {
                this.order.onlineTime = [ this.order.onTime,  this.order.startTimeHour,  this.order.onEndTime  ];

                if (this.order.onlineTime.length == 0) {
                    this.order.onlineTime = "";
                }

                this.order.offlineTime = [ this.order.offTime,  this.order.OffTimeHour,  this.order.offEndTime  ];

                if (this.order.offlineTime.length == 0) {
                    this.order.offlineTime = "";
                }

                // if (this.order.isRenew == 2) {
                //     this.order.renews = null
                // }



                this.order.classHour = this.order.classHour ? Number(this.order.classHour) : 0
                this.order.familyHour = this.order.familyHour ? Number(this.order.familyHour) : 0


                if(this.order.stages && this.order.stages.length > 1){
                  this.order.stages.forEach((itme)=>{
                    itme.agingClassHour = itme.agingClassHour ? Number(itme.agingClassHour) : 0
                    itme.agingFamilyHour = itme.agingFamilyHour ? Number(itme.agingFamilyHour) : 0
                  })
                }else{
                  //  this.order.stages = []
                }

                if(this.order.renews && this.order.renews.length > 1){
                  this.order.renews.forEach((itme)=>{
                    itme.familyHourRenew = itme.familyHourRenew ? Number(itme.familyHourRenew) : 0
                    itme.classHourRenew = itme.classHourRenew ? Number(itme.classHourRenew) : 0
                  })
                }else{
                  //  this.order.renews = []
                }

                this.order.customerIsallpay = this.order.isAllPay

                // this.order.renews = JSON.stringify(this.order.renews)
                // this.order.stages = JSON.stringify(this.order.stages)

                this.order.auditId = this.ApprovalPeople
                this.order.commitRemark = this.chengRemarks

            

                let newObj = {   }

                let list = [];
                if(this.newTextareaJson){
                list = [{ remark: this.newTextareaJson, remarkDate: this.getNowTime() }];
                this.textareaJson.push(...list);
                }


                if(this.typeCustomerFunding === '定金'){

                    if(this.paymentAmount){
                      if(this.paymentAmountTime && this.paymentAmountChannel && this.customerHour && this.customerHourType &&  this.fileAllLists.length > 0 ){
                          
                      }else{
                        this.$message({ message: "请填写必填项",  type: "warning" });
                        return
                      }
                  
                    }


                    newObj = {

                      customerHourType: this.customerHourType ? this.customerHourType : '',
                      classType: this.isClassType ? this.isClassType : '',
                      diagnosisAllPayMoney: this.paymentAmount ? this.paymentAmount : '',
                      diagnosisTime: this.paymentAmountTime ? this.paymentAmountTime : '',
                      payType: this.paymentAmountChannel ? this.paymentAmountChannel : '',
                      customerHour: this.customerHour ? this.customerHour : '',
                      orderStatus: this.OrderStatus ,
                      notCustomerRemark: this.isOrderStatusTextarea ? this.isOrderStatusTextarea : '',


                      regionName: this.regionName ? this.regionName : '',
                      addressTitleName: this.infoObj.value ? this.infoObj.value : '',
                      addressFollow: this.infoObj.address ? this.infoObj.address : '',
                      addressInfo: this.detailedAddress ? this.detailedAddress : '',
                      addressRemark: this.remarks ? this.remarks : '',
                      districtName: this.infoObj.city ? this.infoObj.city : '',
                      latitude: this.infoObj.latitude ? this.infoObj.latitude : '',
                      precisionLng: this.infoObj.precisionLng ? this.infoObj.precisionLng : '',

                      clientNeedRemark:JSON.stringify(this.textareaJson),

                      diagnosisCollectionPicture: this.fileAllLists.length > 0 ? JSON.stringify(this.fileAllLists) : JSON.stringify([]),
                      

                      projectTeacherId: this.customerAccountName111,
                      diagnoseTeacherId: this.customerAccountName11,

                    }
                }


                if(this.typeCustomerFunding === '成单'){

                    let newStringLsit = this.renewalCollectionList.map((itme)=>{
                      let itmes = {

                          projectMoney: itme.Plan,
                          renewMoney: itme.AcademicExpenses || '',
                          classHourRenew: itme.AcademicClasses || '',
                          familyMoney: itme.FamilyEducationExpenses || '',
                          familyHourRenew: itme.FamilyEducationClass || '',
                          readingPartnerMoney: itme.AccompanyingReadingFee || '',
                          readingPartnerHour: itme.AccompanyingReading || '',
                          wayMoney: itme.RemoteRoadRepair || '',
                          renewTime: itme.PaymentTime || '',
                          renewType: itme.Paymentchannel || '',
                          classGiveHour: itme.classGiveHour || '',
                          familyGiveHour: itme.familyGiveHour || '',
                          readingGiveHour: itme.readingGiveHour || '',

                          diagnoseHour: itme.diagnoseHour || '',
                          diagnoseMoney: itme.diagnoseMoney || '',
                          diagnoseGiveHour: itme.diagnoseGiveHour || '',
                          patriarchHour: itme.patriarchHour || '',
                          patriarchGiveHour: itme.patriarchGiveHour || '',
                          patriarchMoney: itme.patriarchMoney || '',
                          studentHour: itme.studentHour || '',
                          studentGiveHour: itme.studentGiveHour || '',
                          studentMoney: itme.studentMoney || '',
                          renewCollectionPicture: itme.renewCollectionPicture && itme.renewCollectionPicture.length > 0 ? JSON.stringify(itme.renewCollectionPicture) : JSON.stringify([]),

                          projectTeacherId: this.customerAccountName111,
                          diagnoseTeacherId: this.customerAccountName11,

                      }
                      return itmes
                    })



                    if(this.setWay === '全款' ){

                        
                          newObj = {
                            classType: this.isClassType ? this.isClassType : '',

                            projectMoney: this.Plan ? this.Plan  : '',
                            allPayMoney: this.AcademicExpenses ? this.AcademicExpenses  : '',
                            classHour: this.AcademicClasses ? this.AcademicClasses  : '',
                            familyHour: this.FamilyEducationClass ? this.FamilyEducationClass  : '',
                            familyMoney: this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : '',
                            readingPartnerMoney: this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : '',
                            readingPartnerHour: this.AccompanyingReading ? this.AccompanyingReading  : '',
                            
                            wayMoney: this.RemoteRoadRepair ? this.RemoteRoadRepair  : '',
                            payTime: this.PaymentTime ? this.PaymentTime  : '',
                            payAlltype: this.Paymentchannel ? this.Paymentchannel  : '',
                            
                            classGiveHour: this.classGiveHour ? this.classGiveHour  : '',
                            familyGiveHour: this.familyGiveHour ? this.familyGiveHour  : '',
                            readingGiveHour: this.readingGiveHour ? this.readingGiveHour  : '',
                            
                            stages: JSON.stringify([]),
                            renews: newStringLsit ? JSON.stringify(newStringLsit) : '[]',

                            isAllPay: this.isThereACharge ? this.isThereACharge : '',
                            isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                            isReturnPremium: this.isThereARefund ? this.isThereARefund : '',
                            auditId: this.ApprovalPeople ? this.ApprovalPeople : '',
                            commitRemark: this.chengRemarks ? this.chengRemarks : '',

                            isClose: this.isCustomsDeclaration,
                            closeCause: this.isCustomsDeclarationchengRemarks,




                            projectMoney: this.Plan,
                            diagnoseMoney: this.diagnoseMoney,
                            diagnoseHour: this.diagnoseHour,
                            diagnoseGiveHour: this.diagnoseGiveHour,
                            studentMoney: this.studentMoney,
                            studentHour: this.studentHour,
                            studentGiveHour: this.studentGiveHour,
                            patriarchMoney: this.patriarchMoney,
                            patriarchHour: this.patriarchHour,
                            patriarchGiveHour: this.patriarchGiveHour,
                            chargeCollectionPicture: this.chargeCollectionPicture.length > 0 ? JSON.stringify(this.chargeCollectionPicture) : JSON.stringify([]),


                            collectionType: this.setWay === '全款' ? 1 : this.setWay === '分期' ? 2 : '',
                            isProject: this.isProject,
                            contractCost: this.contractAmount,

                            projectTeacherId: this.customerAccountName111,
                            diagnoseTeacherId: this.customerAccountName11,

                          }
                        
                    }


                    if(this.setWay === '分期' ){

                        let renewalCollectionListWay =  this.renewalCollectionListWay.map((itme,index)=>{
                              return {
                                  
                                    projectMoney: itme.Plan || '',
                                    diagnoseMoney: itme.diagnoseMoney || '',
                                    customerAllpaymoney: itme.AcademicExpenses || '',
                                    familyMoney: itme.FamilyEducationExpenses || '',
                                    patriarchMoney: itme.patriarchMoney || '',
                                    studentMoney: itme.studentMoney || '',
                                    wayMoney: itme.AccompanyingReadingFee || '',
                                    readingPartnerMoney: itme.RemoteRoadRepair || '',

                                    stagesDate:itme.PaymentTime || '',
                                    payType: itme.Paymentchannel || '',
                                    stagesPicture: itme.chargeCollectionPicture ? JSON.stringify(itme.chargeCollectionPicture) : JSON.stringify([]),

                                    diagnoseHour: itme.diagnoseHour,
                                    diagnoseGiveHour: itme.diagnoseGiveHour,
                                    studentHour: itme.studentHour,
                                    studentGiveHour: itme.studentGiveHour,
                                    patriarchHour: itme.patriarchHour,
                                    patriarchGiveHour: itme.patriarchGiveHour,

                                    classHour: itme.AcademicClasses ? itme.AcademicClasses  : '',
                                    familyHour: itme.FamilyEducationClass ? itme.FamilyEducationClass  : '',
                                    readingPartnerHour: itme.AccompanyingReading ? itme.AccompanyingReading  : '',
                                    payTime: itme.PaymentTime ? itme.PaymentTime  : '',
                                    payAlltype: itme.Paymentchannel ? itme.Paymentchannel  : '',
                                    classGiveHour: itme.classGiveHour ? itme.classGiveHour  : '',
                                    familyGiveHour: itme.familyGiveHour ? itme.familyGiveHour  : '',
                                    readingGiveHour: itme.readingGiveHour ? itme.readingGiveHour  : '',
                                  } 
                        })



                        newObj = {
                        
                          classType: this.isClassType ? this.isClassType : '',

                          renews: newStringLsit ? JSON.stringify(newStringLsit) : '[]',
                          isAllPay: this.isThereACharge ? this.isThereACharge : '',
                          isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                          isReturnPremium: this.isThereARefund ? this.isThereARefund : '',
                          auditId: this.ApprovalPeople ? this.ApprovalPeople : '',
                          commitRemark: this.chengRemarks ? this.chengRemarks : '',
                          isClose: this.isCustomsDeclaration,
                          closeCause: this.isCustomsDeclarationchengRemarks,


                          collectionType: this.setWay === '全款' ? 1 : this.setWay === '分期' ? 2 : '',
                          isProject: this.isProject,
                          contractCost: this.contractAmount,

                          stages: renewalCollectionListWay ? JSON.stringify(renewalCollectionListWay) : '[]',

                          projectTeacherId: this.customerAccountName111,
                          diagnoseTeacherId: this.customerAccountName11,

                        }

                    }
                    
                }


                if(this.typeCustomerFunding === '退费'){
                    newObj = {
                      classType: this.isClassType || '',
                      customerReturnType: this.isWantToContinueTheClass || '',
                      projectTeacherId: this.customerAccountName111,
                      diagnoseTeacherId: this.customerAccountName11,

                      returnPremium: JSON.stringify({
                          projectMoney: this.Plan || '',
                          returnPremiumPrice: this.AcademicExpenses || '',
                          returnPremiumHour: this.AcademicClasses || '',
                          familyMoney: this.FamilyEducationExpenses || '',
                          familyHourRenew: this.FamilyEducationClass || '',
                          readingPartnerMoney: this.AccompanyingReadingFee || '',
                          readingPartnerHour: this.AccompanyingReading || '',
                          wayMoney: this.RemoteRoadRepair || '',
                          returnPremiumDate: this.PaymentTime || '',
                          returnPremiumPayType: this.Paymentchannel || '',

                          projectMoney: this.Plan ? this.Plan  : '',
                          allPayMoney: this.AcademicExpenses ? this.AcademicExpenses  : '',
                          classHour: this.AcademicClasses ? this.AcademicClasses  : '',
                          familyHour: this.FamilyEducationClass ? this.FamilyEducationClass  : '',
                          familyMoney: this.FamilyEducationExpenses ? this.FamilyEducationExpenses  : '',
                          readingPartnerMoney: this.AccompanyingReadingFee ? this.AccompanyingReadingFee  : '',
                          readingPartnerHour: this.AccompanyingReading ? this.AccompanyingReading  : '',
                                
                          wayMoney: this.RemoteRoadRepair ? this.RemoteRoadRepair  : '',
                          payTime: this.PaymentTime ? this.PaymentTime  : '',
                          payAlltype: this.Paymentchannel ? this.Paymentchannel  : '',
                          
                          classGiveHour: this.classGiveHour ? this.classGiveHour  : '',
                          familyGiveHour: this.familyGiveHour ? this.familyGiveHour  : '',
                          readingGiveHour: this.readingGiveHour ? this.readingGiveHour  : '',
                          projectMoney: this.Plan,
                          diagnoseMoney: this.diagnoseMoney,
                          diagnoseHour: this.diagnoseHour,
                          diagnoseGiveHour: this.diagnoseGiveHour,
                          studentMoney: this.studentMoney,
                          studentHour: this.studentHour,
                          studentGiveHour: this.studentGiveHour,
                          patriarchMoney: this.patriarchMoney,
                          patriarchHour: this.patriarchHour,
                          patriarchGiveHour: this.patriarchGiveHour,
                          chargeCollectionPicture: this.chargeCollectionPicture.length > 0 ? JSON.stringify(this.chargeCollectionPicture) : JSON.stringify([]),



                      }),

                      isContinueType: this.isWantToContinueTheClass || '',
                      auditId: this.ApprovalPeople || '',
                      commitRemark: this.chengRemarks || '',




                      classType: this.isClassType ? this.isClassType : '',
                      isAllPay: this.isThereACharge ? this.isThereACharge : '',
                      isRenew: this.isYouWantToRenew ? this.isYouWantToRenew : '',
                      isReturnPremium: this.isThereARefund ? this.isThereARefund : '',
                      auditId: this.ApprovalPeople ? this.ApprovalPeople : '',
                      commitRemark: this.chengRemarks ? this.chengRemarks : '',

                      isClose: this.isCustomsDeclaration,
                      closeCause: this.isCustomsDeclarationchengRemarks,



                      


                      collectionType: this.setWay === '全款' ? 1 : this.setWay === '分期' ? 2 : '',
                      isProject: this.isProject,
                      contractCost: this.contractAmount,

                    }
                }


                let keys = Object.keys(newObj)
                keys.forEach((key)=>{
                  if (this.order.hasOwnProperty(key)) {
                      delete this.order[key]
                  }
                })
                let dateObj = Object.assign(newObj, this.order)
                let isUrView = this.isUrView


                dateObj.customerId = this.customerId
                dateObj.customerInformationId = this.order.customerInformationId
                dateObj.saleId  = this.orderSaleId  

                dateObj.prepareAddressList = this.ListDataLngLat
                console.log(dateObj.prepareAddressList, 'dateObj.prepareAddress》》》')

                if(this.isClassType){
                  this.loginStb = true
                  axios.post(`${apiBaseUrl}${isUrView}`, dateObj,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                        this.loginStb = false
                        if (res.data.code === 200) {

                          this.$message({  message: "编辑成功",  type: "success" });


                          this.$emit("newModesCustomerFundingDetailEvent");

                          this.$emit("refreshOrder");
                          this.showEdit = false;
                          this.ListDataLngLat = []

                          this.infoObj = {}
                          this.remarks = ''
                          this.detailedAddress = ''
                          this.newaddress = ''  
                          this.regionName = ''

                          this.customerAccountName11 = ''
                          this.customerAccountName111 = ''
                              

                          this.ApprovalPeople = "";
                          this.chengRemarks = "";
                          this.order.auditId = "";
                          this.order.commitRemark = "";

                          this.order.isDiagnosisAllPay = "";
                          this.order.diagnosisAllPayMoney = "";
                          this.order.diagnosisTime = "";
                          this.order.diagnosisPayType = "";
                          this.order.isAllPay = "";
                          this.order.allPayMoney = "";
                          this.order.payTime = "";
                          this.order.payType = "";

                          this.order.startTimeHour = ""
                          this.order.onEndTime = ""
                          this.order.OffTimeHour = ""
                          this.order.offEndTime = ""

                          this.order.classHour = ""
                          this.order.familyHour = ""

                          this.order.renews = [{  renewMoney: "",  renewTime: "",   renewType: ""  , classHourRenew: "", familyHourRenew: "" }]

                          this.order.stages = [ { stagesMoney: "",  stagesDate: "",   payType: "" , agingClassHour: "", agingFamilyHour: "" }]

                          this.$refs.order.resetFields();
                          // this.order.startTime.splice(0, this.order.startTime.length);
                        } else {
                            this.$message({ message: res.data.msg ? res.data.msg : res.data.message, type: "error"  });
                            this.order.classHour = this.order.classHour ? Number(this.order.classHour) : ""
                            this.order.familyHour = this.order.familyHour ? Number(this.order.familyHour) : ""

                            if(this.order.stages.length > 1){
                              this.order.stages.forEach((itme)=>{
                                itme.agingClassHour = itme.agingClassHour ? Number(itme.agingClassHour) : ""
                                itme.agingFamilyHour = itme.agingFamilyHour ? Number(itme.agingFamilyHour) : ""
                              })
                            }

                            if(this.order.renews.length > 1){
                              this.order.renews.forEach((itme)=>{
                                itme.familyHourRenew = itme.familyHourRenew ? Number(itme.familyHourRenew) : ""
                                itme.classHourRenew = itme.classHourRenew ? Number(itme.classHourRenew) : ""
                              })
                            }
                        }
                      }).catch(()=>{
                         this.loginStb = false
                      })
                //   }
                // });
                    this.$emit("refresh");
                }else{
                  this.$message({ message: "请选择学生类型", type: "warning"  });
                }
      }


     
         
    }


    },



  }



</script>



<style scoped >

.add{
  pointer-events: none;
}

.el-collapse-item__header{
     margin-left: 180px;
}

.inputcolor > .el-input__inner{
  color: red !important;
}

.my-dialog > .el-dialog {
  text-align: center;
}

.init-b{
    text-align: start;
    padding-left: 10px;
    height: 100px;
    margin-top: 14px;
    overflow-y: auto;
    border: 1px solid #dcd5d5;
    border-radius: 2px;
    padding-top: 10px;
    margin-left: 10px;
    width: 50%;
}

</style>



// WEBPACK FOOTER //
// src/CustomerFundingAll/newModesCustomerFundingDetail.vue